export const uaLangDashboard = {
  common: {
    you: 'Ви',
    post: 'Пост',
    article: 'Стаття',
    create: 'Створити',
    message: 'Повідомлення',
    popular: 'Популярні',
    emptyIntegrations: 'Вам потрібно добавити інтеграції спочатку',
    categories: 'Категорії',
    edit: 'Редагувати',
    share: 'Поділитися',
    plan: 'План',
    sort: 'Сортування',
    addArticle: 'Додати статтю',
    articles: 'Статті',
    users: 'користувачі',
    scans: 'скани',
    clicks: 'кліків',
    copy: 'Копіювати',
    customize: 'Налаштувати',
    link: 'Посилання',
    save: 'Зберегти',
    uploadFile: 'Завантажити файл',
    customImage: 'Власне зображення',
    customImageTooltip: 'Завантажте власне зображення',
    size: 'Розмір',
    sizeTooltip: 'Перетягніть повзунок, щоб встановити розмір',
    auto: 'Авто',
    rectangle: 'Прямокутник',
    custom: 'Власний',
    clean: 'Очистити',
    cleaning: 'Очищення',
    download: 'Завантажити',
    downloading: 'Завантаження',
    preview: 'ПОПЕРЕДНІЙ ПЕРЕГЛЯД',
    cover: 'Обкладинка',
    coverTooltip: 'Завантажте фото обкладинки',
    title: 'Заголовок',
    new: 'Новий',
    pro: 'Pro',
    free: 'Free',
    limit: 'Ліміт',
    websites: 'сайти',
    site: 'Сайт',
    apiKey: 'API-ключ',
    name: "Ім'я",
    passwordChange: 'Змінити пароль',
    draft: 'Чернетка',
    page: 'Сторінка',
    areYouSure: 'Ви впевнені?',
    drop: 'Перетягніть',
    video: 'відео',
    image: 'зображення',
    chooseFile: 'Вибрати файл',
    nothingFound: 'Нічого не знайдено',
    enterCorrectLink: 'Введіть правильне посилання',
    off: 'Вимкнено',
    disconnect: 'ВІДКЛЮЧИТИ',
    connect: 'ПІДКЛЮЧИТИ',
    copied: 'Скопійовано',
    saved: 'Збережено',
    lostConnection: "Втрачено зв'язок",
    addedCategory: 'Додано категорію',
    none: 'Без',
    left: 'Ліворуч',
    right: 'Праворуч',
    solid: 'Товста',
    double: 'Подвійна',
    welcome: 'Ласкаво просимо',
    category: 'Категорія',
    product: 'Продукт',
    website: 'Сайт',
    items: 'Елементи',
    square: 'Квадрат',
    round: 'Круг',
    border: 'Грані',
    shadow: 'Тінь',
    soft: "М'яка",
    hard: 'Жорсткий',
    block: 'Блок',
    primary: 'Головний',
    additional: 'Додатковий',
    normal: 'Звичайний',
    bold: 'Товстий',
    uploadVideo: 'Завантажити відео',
    compact: 'Компактно',
    card: 'Картка',
    top: 'Зверху',
    center: 'Центр',
    bottom: 'Знизу',
    button: 'Кнопка',
    addNewItem: 'Додати новий елемент',
    price: 'Ціна',
    priceCaption: 'Додайте ціну вашого продукту',
    oldPrice: 'Стара ціна',
    oldPriceCaption: 'Стара ціна буде закреслена',
    areYouSureDeleteItem: 'Ви впевнені, що хочете видалити цей елемент?',
    add: 'Додати',
    active: 'Активний',
    isActive: 'активний',
    isDisabled: 'вимкнено',
    uploadImage: 'Завантажити картинку',
    design: 'Дизайн',
    addAccount: 'Додати обліковий запис',
    hey: 'Привіт',
    activeBackground: 'Активний фон',
    activeText: 'Активний текст',
    connectDomain: 'Підключити домен',
    shortLink: 'Коротке посилання',
    appearanceSaved: 'Зовнішній вигляд збережено!',
    blockAdded: 'Блок додано!',
    comingSoon: 'Незабаром',
    easyMoney: 'Легкі гроші',
    content: 'Контент',
    audience: 'Аудиторія',
    view: 'Переглянути',
    delete: 'Видалити',
    file: 'Файл',
    type: 'Тип',
    from: 'Від',
    to: 'До',
    fullName: "Повне ім'я",
    lastTimeUsed: 'Останнє використання',
    noMediaFiles: 'Поки що немає медіафайлів...',
    withdraw: 'Вивести',
    congrats: 'Вітаємо!',
    makeMoneyOnline: 'Заробляйте гроші онлайн!',
  },
  sort: {
    title: 'Сортування',
    search: 'Пошук',
    default: 'Сортування за замовчуванням',
    dateNew: 'Дата: від нових до старих',
    dateOld: 'Дата: від старих до нових',
    priceLow: 'Ціна: від нижчої до вищої',
    priceHigh: 'Ціна: від вищої до нижчої',
    nameA: 'Назва: A до Я',
    nameZ: 'Назва: Я до A',
    popular: 'Найпопулярніші',
  },
  emailMenu: {
    broadcasts: 'Трансляції',
    automations: 'Автоматизація',
    templates: 'Шаблони',
    settings: 'Налаштування',
    noEmails: 'Поки що немає електронних листів',
    newBroadcast: 'Нові трансляції',
  },
  aiContent: {
    title: 'Створіть свій перший контентний ШІ!',
    text: 'Плануйте та публікуйте контент у всіх соціальних мережах одночасно!',
    create: 'Створити ШІ контент',
  },
  pageDesign: {
    page: 'Сторінка',
    image: 'Картинка',
  },
  toolsMenu: {
    title: 'Інструменти',
    account: 'Аккаунт',
    instantPages: 'Миттєві сторінки',
    instantPagesText: 'Швидкозавантажувані окремі сторінки',
    agents: 'Агенти',
    agentsText: 'AI-асистенти для управління профілем',
    socialPlanner: 'Планувальник контенту',
    socialPlannerText: 'Планування та натхнення для контенту',
    emailMarketing: 'Email-маркетинг',
    emailMarketingText: 'Збільшуйте базу контактів',
    smartReply: 'Розумна відповідь',
    smartReplyText: 'Автовідповіді та коментарі',
    linkShortener: 'Скорочувач посилань',
    linkShortenerText: 'Скорочуйте довгі URL-адреси',
    posts: 'Пости',
    postsText: 'Створення та управління постами',
    blog: 'Блог',
    blogText: 'Створення та управління постами',
  },
  insideMenu: {
    planner: 'Планувальник',
    aiContent: 'AI-контент',
    aiPosts: 'AI-пости',
    postIdeas: 'Ідеї постів',
    contentPlanner: 'Контент-планер',
    aiImages: 'AI-зображення',
    brandProjects: 'Брендові проєкти',
    aiVideo: 'AI-відео',
    integrations: 'Інтеграції',
    products: 'Товари',
    orders: 'Замовлення',
    payments: 'Платежі',
    links: 'Посилання',
    qrCodes: 'QR-коди',
  },
  orders: {
    title: 'Замовлення',
    empty: 'У вас ще немає замовлень',
    all: 'Усі замовлення',
    shop: 'Магазин',
    digital: 'Цифрові продукти',
    appointments: 'Призначення',
    services: 'Послуги',
    donations: 'Донати',
  },
  discounts: {
    title: 'Знижки',
    newDiscount: '+ Нова знижка',
    code: 'Код',
    titleCol: 'Назва',
    type: 'Тип',
    value: 'Значення',
    status: 'Статус',
    used: 'Використано',
    actions: 'Дії',
    statusAll: 'Всі статуси',
    statusActive: 'Активна',
    statusExpired: 'Закінчилась',
    statusScheduled: 'Запланована',
    statusInactive: 'Неактивна',
    searchPlaceholder: 'Пошук за кодом або назвою...',
    clearFilters: 'Очистити фільтри',
    emptyTitle: 'Ще немає знижок',
    emptySubtitle: 'Створіть свій перший промокод, щоб пропонувати знижки на свої товари',
    createDiscount: 'Створити знижку',
    createTitle: 'Створити знижку',
    editTitle: 'Редагувати знижку',
    fieldTitle: 'Назва',
    fieldTitlePlaceholder: 'напр. Весняний розпродаж',
    fieldCode: 'Код',
    fieldCodePlaceholder: 'напр. SAVE20',
    generate: 'Згенерувати',
    sectionDiscount: 'Знижка',
    fieldType: 'Тип',
    typePercentage: 'Відсоток',
    typeFixed: 'Фіксована сума',
    typeFreeShipping: 'Безкоштовна доставка',
    fieldValue: 'Значення',
    sectionConditions: "Умови (необов'язково)",
    appliesTo: 'Застосовується до',
    appliesToAll: 'Всі товари',
    appliesToShop: 'Магазин',
    appliesToDigital: 'Цифрові',
    appliesToCourses: 'Курси',
    appliesToServices: 'Послуги',
    appliesToEvents: 'Події',
    minOrderAmount: 'Мінімальна сума замовлення ($)',
    maxDiscountAmount: 'Максимальна сума знижки ($) — 0 = без ліміту',
    minItemCount: 'Мін. кількість товарів — 0 = без вимоги',
    specificProducts: 'Конкретні товари — порожньо = всі',
    specificProductsPlaceholder: 'Пошук товарів...',
    noProductsFound: 'Товарів не знайдено',
    sectionLimits: 'Ліміти',
    usageLimit: 'Загальний ліміт використання — 0 = без ліміту',
    usageLimitPerUser: 'Ліміт на клієнта — 0 = без ліміту',
    sectionSchedule: 'Розклад',
    startDate: 'Дата початку — порожньо = починається зараз',
    endDate: 'Дата закінчення — порожньо = без терміну',
    active: 'Активна',
    cancel: 'Скасувати',
    save: 'Зберегти знижку',
    createdSuccess: 'Знижку створено',
    updatedSuccess: 'Знижку оновлено',
    deletedSuccess: 'Знижку видалено',
    loadError: 'Не вдалося завантажити знижки',
    saveError: 'Не вдалося зберегти знижку',
    deleteError: 'Не вдалося видалити знижку',
  },
  donation: {
    chooseSmiles: 'Виберіть смайли',
    item: 'Елемент',
    itemTitle: 'Назва елемента донату',
    price: 'Ціна',
    thanksMessagePlaceholder: 'Дуже дякую',
    thanksMessage: 'Повідомлення подяки',
    thanksMessageCaption: 'Повідомлення подяки буде показано вашим фанам після донату',
    addDonation: 'Додати донат',
    addAmount: '+ Додати суму',
    buttonTitle: 'Назва кнопки',
    buttonTitleCaption: 'Назва кнопки донату',
    acceptDonations: 'Приймати донати',
    donationsType: 'Донати',
    tips: 'Чайові',
    type: 'Тип',
    addAnotherAmount: '+ Додати ще одну суму',
  },
  blog: {
    empty: 'У вас ще немає постів',
  },
  apps: {
    empty: 'У вас ще немає програм',
  },
  payments: {
    title: 'Платежі',
    text: 'У вас ще немає жодної транзакції',
    single: 'Одноразові платежі',
    subscriptions: 'Підписки',
    wallet: 'Гаманець',
    connectPromo: 'Підключіть акаунт Stripe або PayPal до вашої сторінки UniLink та отримуйте всі платежі на свій гаманець.',
    connectSystem: 'Підключити платіжну систему',
    manageCards: 'Керувати картками',
    addNewCard: 'Додати нову картку',
    editCard: 'Редагувати дані картки',
    addCard: 'Додати дані картки',
    cardHolder: 'Ім’я власника картки',
    cardHolderNecessary: 'Це обов’язково',
    withdrawalSuccess: 'Ваш запит на виведення коштів успішно надіслано!',
    withdrawalError: 'Щось пішло не так, спробуйте пізніше.',
    change: 'Змінити',
  },
  store: {
    emptyTitle: 'У вас ще немає товарів',
    emptyText: 'Почніть з додавання вашого першого товару',
    emptyButton: 'Додати товар',
    createFirstProduct: 'Створіть свій перший продукт',
    startAdding: 'Почніть додавати улюблені продукти, цифрові товари або послуги. Місце, де ви можете продавати та просувати все, що пропонуєте.',
    activate: 'Активувати магазин',
    empty: 'У вас ще немає продуктів',
    products: 'Продукти',
    addProducts: 'Додати продукти',
    whatDoYouWant: 'Що ви хочете продати?',
    externalProduct: 'URL зовнішнього продукту',
    createOwnProduct: 'Створити свій власний продукт',
    shop: 'Магазин',
    shopText: 'Продавайте фізичні та цифрові продукти',
    digital: 'Цифрові продукти',
    digitalText: 'Продавайте цифрові завантаження',
    course: 'Курс або навчальний посібник',
    courseText: 'Додайте курс або навчальний посібник на сайт',
    service: 'Послуги',
    serviceText: 'Додайте послуги від ваших клієнтів',
    appointment: 'Записи на прийом',
    appointmentText: 'Дайте можливість відвідувачам записуватися на ваш календар',
    event: 'Події або квитки',
    eventText: 'Створіть подію та запросіть аудиторію',
    tips: 'Чайові',
    tipsText: 'Залиште чайові улюбленим авторам',
    donation: 'Підказки або пожертвування',
    donationText: 'Зробити пожертвування',
    membership: 'Членство',
    membershipText: 'Додайте членство на вебсайт',
    links: 'Посилання',
    linksText: 'Додати посилання на будь-який веб-сайт',
    coupon: 'Купон',
    couponText: 'Додати купон на вебсайт',
    singleProduct: 'Один продукт',
    singleProductText: 'Продавайте один продукт із простим замовленням',
    booking: 'Бронювання',
    bookingText: 'Дозвольте відвідувачам бронювати ваші приміщення',
    rental: 'Оренда',
    rentalText: 'Здавайте в оренду з доступністю та ціною за період',
    add: 'Додати',
    manageStore: 'Керувати магазином',
    displayLast: 'Показати останній продукт',
  },
  products: {
    info: 'Інформація',
    uploadCover: 'Завантажте обкладинку, потім вкажіть назву та опис',
    thumbnail: 'Мініатюра',
    thumbnailError: 'Будь ласка, додайте мініатюру',
    title: 'Назва',
    titleTooltip: 'Введіть назву вашого товару',
    shortDescription: 'Короткий опис',
    shortDescriptionTooltip: 'Введіть короткий опис вашого товару',
    description: 'Опис',
    descriptionTooltip: 'Введіть опис вашого товару',
    descriptionTooltipExtra: 'Необов’язковий опис характеристик товару, типів, кольорів, розмірів тощо',
    price: 'Ціна',
    priceTooltip: 'Введіть ціну вашого товару',
    oldPrice: 'Стара ціна',
    oldPriceTooltip: 'Стара ціна буде перекреслена',
    category: 'Категорія',
    categoryTooltip: 'Оберіть категорію вашого товару',
    image: 'Зображення',
    imageTooltip: 'Завантажте зображення товару',
    groups: 'Групи',
    rate: 'Оцінка',
    rateTooltip: 'Введіть оцінку вашого товару',
    buttonTitle: 'Назва кнопки',
    buttonTitleTooltip: 'Введіть назву кнопки для товару',
    limitQuantity: 'Обмежити кількість',
    itemsLeft: 'Залишилось одиниць',
    itemsLeftTooltip: 'Кількість доступних одиниць товару',
    attachments: 'Додатки',
    addAttachments: 'Додайте додатки до вашого товару',
    addNewAttachment: 'Додати новий файл',
    file: 'Файл',
    uploadFile: 'Завантажити файл',
    uploadCoverTitle: 'Завантажити обкладинку',
    optionalDescription: 'Необов’язковий опис характеристик товару, типів, кольорів, розмірів тощо',
    customReviews: 'Користувацькі відгуки',
    addCustomReviews: 'Додати відгуки до товару',
    name: 'Ім’я',
    nameTooltip: 'Введіть ім’я клієнта',
    comment: 'Коментар',
    commentTooltip: 'Введіть коментар клієнта',
    rateTooltipCustomer: 'Оцінка клієнта',
    imageTooltipCustomer: 'Завантажте зображення клієнта',
    displayPriceOnPreview: 'Показати ціну на попередньому перегляді',
    displayDetailsOnPreview: 'Показати деталі на попередньому перегляді',
    postOnSocials: 'Опублікувати в соцмережах',
    sendAnEmail: 'Надіслати Email',
    highlights: 'Виділене',
    listProductSetup: 'Додайте товар і налаштуйте блок магазину',
    whereToSell: 'Де ви хочете продати цей товар?',
    youHaveProducts: 'У вас {count} товарів',
    shareThisProduct: 'Поділитися цим товаром',
    shareAProduct: 'Поділитися товаром',
    monetizeWays: 'Різні способи монетизації на Unilink',
    addProductToProfile: 'Додати {title} до вашого профілю',
    productPage: 'Сторінка продукту',
    setUpPayments: 'Налаштуйте платежі',
    connectPaymentMethods: 'Підключіть платіжні методи, щоб почати заробляти гроші на Unilink',
    addPaymentMethod: 'Додайте платіжний метод {type} для отримання платежів від підписників',
    withdrawAttempt: 'Це спроба стягнення боргу, і будь-яка інформація буде використана для цієї мети.',
    withdrawSuccess: 'Ваш запит на виведення коштів успішно надіслано!',
    yourVisitorsPay: 'Ваші відвідувачі спочатку оплатять, а потім будуть перенаправлені на ваш {method}',
    emailAddress: 'email адресу',
    calendlyLink: 'посилання Calendly',
  },
  posts: {
    posts: 'Пости',
    title: 'Створіть свій перший пост',
    description: 'Пости — це місце, де ви створюєте автоматизацію чатів у легкому та візуальному форматі. Спробуйте деякі автоматизації, які ми рекомендуємо на основі ваших цілей',
    activate: 'Активувати Пости',
    managePosts: 'Керувати Постами',
    postsTab: 'Вкладка Постів',
    displayLast: 'Відображати останні пости',
    tabNavigation: 'Налаштування навігації вкладок',
    createFirstPost: 'Створіть свою першу публікацію в соціальних мережах!',
    autoPostsText: 'Плануйте та публікуйте контент у всіх соціальних мережах одночасно!',
    createPost: 'Створити публікацію',
  },
  messages: {
    title: 'Повідомлення',
    empty: 'Немає повідомлень',
    addText: 'Додайте кнопку повідомлення до блоку заголовка, щоб користувачі могли легко надіслати вам повідомлення.',
    addButton: 'Додати кнопку повідомлення',
  },
  smartReply: {
    title: 'Розумна відповідь',
    clicks: 'кліки',
    createTitle: 'Створіть свою першу розумну відповідь!',
    text: 'Використовуйте автоматичні особисті повідомлення в Instagram, щоб автоматично ділитися посиланнями зі своєю аудиторією!',
    createButton: 'Створити розумну відповідь',
  },
  shortLinks: {
    title: 'Короткі посилання',
    addLink: 'Додати посилання',
    name: 'Назва',
    slug: 'Слаг',
    slugTooltip: 'Ви можете змінити Слаг, натиснувши кнопку редагування.',
    destinationUrl: 'URL призначення',
    metadata: 'Метадані',
    utmTags: 'UTM теги',
    customizeMetadata: 'Налаштувати метадані посилання',
    metaTitle: 'Заголовок',
    metaDescription: 'Опис',
    favicon: 'Favicon',
    imagePreview: 'Попередній перегляд зображення',
    addUtm: 'Додати UTM теги до посилання (опціонально)',
    utmCampaign: 'UTM Кампанія',
    utmMedium: 'UTM Медійний канал',
    utmSource: 'UTM Джерело',
    utmTerm: 'UTM Терміни',
    utmContent: 'UTM Контент',
    utmId: 'UTM Ідентифікатор',
    utmPlacement: 'UTM Розміщення',
    utmCreative: 'UTM Креатив',
    pasteLink: 'Вставте сюди своє довге посилання',
    shorten: 'Скоротити посилання',
    edit: 'Редагувати деталі',
  },
  audience: {
    title: 'Аудиторія',
    total: 'Усього',
    totalMembers: 'Усього учасників аудиторії',
    totalContacts: 'Усього контактів',
    forms: 'Форми',
    subscribers: 'Підписники',
    customers: 'Клієнти',
    noAudienceMembers: 'Немає контактів',
    emptyAudienceMembers: 'Додайте нових контактів, натиснувши кнопку',
    addAudienceMember: 'Додати контакт',
    noSubscribers: 'Немає підписників',
    emptySubscribers: 'Додайте нових підписників, додаючи блоки до вашого Link in Bio',
    addDataCollect: 'Додати блок збору даних',
    noResponses: 'Немає відповідей',
    emptyResponses: 'Додайте нові відповіді, додаючи блоки до вашого Link in Bio',
    addFormBlock: 'Додати блок форми',
    noCustomers: 'Немає клієнтів',
    emptyCustomers: 'Додайте нових клієнтів, додаючи продукти до вашого Link in Bio',
    addProduct: 'Додати продукт',
    addContactModal: {
      title: 'Додати новий контакт',
      name: 'Ім’я',
      nameTooltip: 'Введіть ім’я вашого контакту',
      email: 'Електронна пошта',
      emailTooltip: 'Введіть адресу електронної пошти вашого контакту',
      phone: 'Телефон',
      phoneTooltip: 'Введіть номер телефону вашого контакту',
      telegram: 'Telegram',
      telegramTooltip: 'Введіть ім’я користувача або URL Telegram вашого контакту',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Введіть номер WhatsApp вашого контакту',
      instagram: 'Instagram',
      instagramTooltip: 'Введіть ім’я користувача або URL Instagram вашого контакту',
      messenger: 'Messenger',
      messengerTooltip: 'Введіть ім’я користувача або URL Messenger вашого контакту',
      viber: 'Viber',
      viberTooltip: 'Введіть номер Viber вашого контакту',
      address: 'Адреса',
      addressTooltip: 'Введіть адресу вашого контакту',
      add: 'Додати',
    },
    search: {
      search: 'Пошук',
      error: 'Введено недопустимий символ у поле пошуку',
      notFound: 'Результати не знайдені',
    },
  },
  auth: {
    logIn: 'Увійти',
    logInWith: 'Увійти за допомогою',
    signIn: 'Увійти',
    signInWith: 'Зареєструватися за допомогою',
    email: 'Електронна пошта',
    password: 'Пароль',
    notHaveAccount: 'Немає акаунту?',
    createAccount: 'Створити новий акаунт',
    createYourAccount: 'Створіть ваш акаунт',
    signUp: 'Зареєструватися',
    haveAccount: 'Якщо у вас вже є акаунт',
    or: 'або',
    reset: 'Скинути',
    resetPassword: 'Скинути пароль',
    resetTitle: 'Посилання для відновлення надіслано на вашу електронну пошту',
    goToHome: 'Перейти на головну сторінку',
    byClicking: 'Натискаючи',
    youAreAgree: 'ви погоджуєтесь з',
    terms: 'Умовами використання UniLink',
    andConfirm: 'та нашу',
    usagePolicy: 'Політику використання',
    signInGoogle: 'Увійти з Google',
    forgotPassword: 'Забули пароль?',
  },
  menu: {
    moreApps: 'Більше додатків',
    account: 'Акаунт',
    more: 'Більше',
    storyWidget: 'Embed Stories',
    integrations: 'Інтеграції',
    socialAccounts: 'Соціальні акаунти',
    aiContent: 'AI-контент',
    aiPosts: 'AI-пости',
    postIdeas: 'Ідеї постів',
    contentPlanner: 'Контент-планер',
    aiImages: 'AI-зображення',
    aiVideo: 'AI-відео',
    planner: 'Автопостинг',
    customers: 'Клієнти',
    subscribers: 'Підписники',
    forms: 'Форми',
    allAudience: 'Вся аудиторія',
    payments: 'Платежі',
    orders: 'Замовлення',
    products: 'Продукти',
    events: 'Події',
    appointments: 'Записи',
    discounts: 'Знижки',
    affiliates: 'Партнери',
    instantPages: 'Миттєві сторінки',
    openInNewTab: 'Відкрити в новій вкладці',
    linkInBio: 'Link in Bio',
    linkInBioApps: 'Link in Bio',
    website: 'Сайт',
    store: 'Магазин',
    audience: 'Аудиторія',
    emailMarketing: 'Email-маркетинг',
    postPlaner: 'Автопостинг',
    posts: 'Пости',
    agents: 'Агенти',
    community: 'Спільнота',
    profileHealth: 'Profile Health',
    socialPlanner: 'Планер соцмереж',
    shortLinks: 'Короткі посилання',
    views: 'Перегляди',
    clicks: 'Кліки',
    allWebsites: 'Усі сайти',
    createNewAccount: 'Створити новий акаунт',
    createNewWebsite: 'Створити новий профіль',
    tools: 'Інструменти',
    borderGenerator: 'Генератор рамок',
    yourPlan: 'Ваш план:',
    upgrade: 'Upgrade',
    accountSettings: 'Налаштування акаунта',
    manageWebsites: 'Керування профілями',
    updates: 'Оновлення',
    autoUpdate: 'Автооновлення',
    logOut: 'Вийти',
    myPages: 'Мої сторінки',
    design: 'Дизайн',
    heading: 'Заголовок',
    analytics: 'Аналітика',
    settings: 'Налаштування',
    open: 'Відкрити',
    language: 'Мова',
    movePage: 'Перемістити сторінку',
    editBlock: 'Редагувати блок',
    renameBlock: 'Перейменувати блок',
    rename: 'Перейменувати',
    deleteBlock: 'Видалити Блок',
    archiveBlock: 'Архівувати блок',
    archive: 'Архівувати',
    scheduleBlock: 'Розклад',
    copyBlock: 'Копіювати Блок',
    dublicateBlock: 'Дублювати Блок',
    content: 'Контент',
    preview: 'Попередній перегляд',
    copy: 'Копіювати',
    moveBlock: 'Перемістити блок',
    move: 'Перемістити',
    edit: 'Редагувати',
    delete: 'Видалити',
    schedule: 'Розклад',
    dublicate: 'Дублювати',
    smartReply: 'Розумна відповідь',
    marketing: 'Маркетинг',
    selectBlocks: 'Вибрати блоки',
    selectAll: 'Вибрати все',
    cancelSelection: 'Скасувати',
    blocksSelected: 'вибрано',
    moveToPage: 'Перемістити на сторінку',
    newPage: 'Нова сторінка',
    openPage: 'Відкрити сторінку',
    pageSettings: 'Налаштування сторінки',
    deletePage: 'Видалити сторінку',
    appInBio: 'App in Bio',
    blog: 'Блог',
    publish: 'Опублікувати',
    creatorHub: 'Центр авторів',
    qrCodes: 'QR-коди',
    apps: 'Apps',
    automations: 'Автоматизації',
    messages: 'Вхідні',
    form: 'Embed Forms',
    embedTools: 'Embed Tools',
  },
  modal: {
    addInstagram: 'Додати Instagram',
    addYourInstagram: 'Додати свій Instagram акаунт',
    cropYourAvatar: 'Обрізати аватарку',
    removeSite: 'Ви впевнені, що хочете видалити сайт?',
    areYouSure: 'Ви впевнені, що хочете',
    areYouSureDelete: 'Ви впевнені, що хочете видалити цю секцію?',
    areYouSureArchive: 'Ви впевнені, що хочете архівувати цей блок?',
    areYouSurePermanentDelete: 'Ви впевнені, що хочете остаточно видалити цей блок? Цю дію неможливо скасувати.',
    remove: 'видалити',
    site: 'сайт',
    removeAccountText: 'видалити свій акаунт',
    moveBlock: 'Перемістити блок на іншу сторінку',
    moveBlockText: 'Це перемістить блок у нижню частину іншої сторінки. Потім ви можете змінити розташування блоку на новій сторінці',
    profileTitle: 'Змінити зображення профілю',
    profileText: 'Виберіть зображення, GIF з вашого пристрою.',
    profileAvatar: 'Аватар профілю',
    addProfilePicture: 'Додати зображення профілю',
    storiesTitle: 'Історії',
    storiesText: 'Поділіться своїми повсякденними моментами.',
    thoughtsTitle: 'Думки',
    thoughtsText: 'Поділіться своїми думками.',
    accountPageDescription: 'Це ваша сторінка облікового запису, де ви можете налаштувати вигляд вашої сторінки, додати різні функціональні блоки та багато іншого.',
  },
  modalSubscribe: {
    plan: 'Тариф',
    usdMonth: 'USD/місяць',
    sites: 'Сайти',
    sitesMuch: 'Сайтів',
    notification: 'Сповіщення',
    noNotification: 'Поки що немає сповіщень',
    inCategory: 'У категорії ',
    categoryYet: 'поки що немає елементів.',
    externalPixels: 'Зовнішні Пікселі',
    parameters: 'параметри',
    analyticsReports: 'Аналітика та Звіти',
    noUniLinkLogo: 'Без логотипу UniLink',
    inProfile: 'в профілі',
    verifiedBadge: 'Верифікаційна галочка',
    your: 'Ваш',
    customDomain: 'власний Домен',
    emailMarketing: 'Email маркетинг',
    liveSupport: 'Підтримка',
    dataSecured: 'Дані захищені відповідно до стандарту PCI DSS',
    thankYou: "Дякуємо за інтерес. Ми зв'яжемося з вами найближчим часом.",
    socialMediaScheduler: 'Планувальник постів у соцмережах',
    featureRequest: 'Запит на функціонал',
    markAllRead: 'Позначити все як прочитане',
    currentPlan: 'Поточний план',
    features: 'Особливості',
  },
  buttons: {
    upgrade: 'Upgrade Plan',
    buyProPlan: 'Купити Pro Тариф',
    continue: 'Продовжити',
    skip: 'Пропустити',
    cancel: 'Скасувати',
    confirm: 'Підтвердити',
    back: 'Назад',
    save: 'Зберегти',
    add: 'Додати',
    added: 'Додано',
    done: 'Готово',
    ok: 'ОК',
    edit: 'Редагувати',
    delete: 'Видалити',
    remove: 'Видалити',
    setAsDefault: 'За замовчуванням',
    subscribeNow: 'Підписатися Зараз',
    yes: 'Так',
    preview: 'Попередній перегляд',
    generate: 'Згенерувати',
    changePassword: 'Змінити пароль',
    deleteAccount: 'Видалити акаунт',
    removeAccount: 'Видалити акаунт',
    deleteProfile: 'Видалити профіль',
    addBlock: 'Додати блок',
    copyLink: 'Копіювати URL',
    active: 'Активна',
    update: 'Оновити',
    updatePro: 'Оновити Тариф',
    prev: 'Попередній',
    next: 'Наступний',
    uploadImage: 'Завантажити зображення',
    uploadVideo: 'Завантажити відео',
    loadMore: 'Завантажити більше',
    uploadProductImage: 'Завантажити зображення продукту',
    claim: 'Отримати',
    removeSite: 'Видалити сайт',
    move: 'Перемістити',
    addButton: 'Додати кнопку',
    actionButton: 'Кнопка дії',
    directMessage: 'Особисте повідомлення',
    subscribe: 'Підписатись',
    button: 'Кнопка',
    generateWithAI: 'Генерувати за допомогою ШІ',
    cta: 'Кнопка дії',
    cart: 'Кошик',
    direct: 'Повідомлення',
    follow: 'Підписка',
    addNewItem: 'Додати новий елемент',
  },
  support: {
    liveSupport: 'Підтримка',
    response: 'Зазвичай ми відповідаємо протягом 1 хвилини в робочий час (8:00-22:00) GMT+3',
    founder: 'Денис Білозор',
    ceo: 'Засновник UniLink',
  },
  wizard: {
    createNewProfile: 'Створити новий профіль',
    createProfile: 'Створити профіль',
    continue: 'Продовжити',
    tellUs: 'Розкажіть щось про себе',
    addSocialLinks: 'Додайте всі соціальні мережі, і ми покажемо їх на вашій сторінці',
    addMoreLinks: 'Додати більше посилань',
    addLink: 'Додати посилання',
    selectCategory: 'Виберіть одну категорію, яка найкраще описує вас:',
    chooseTemplate: 'Виберіть шаблон',
    skip: 'Пропустити',
    step: 'Крок',
    of: 'з',
    yourName: "Ваше ім'я",
    search: 'Пошук',
    blog: 'Блог',
    creator: 'Кріейтор',
    music: 'Музика',
    events: 'Події',
    esoteric: 'Езотерика',
    fashion: 'Мода',
    influencer: 'Інфлюенсер',
    food: 'Їжа',
    smallBusiness: 'Малий бізнес',
    marketing: 'Маркетинг',
    education: 'Освіта',
    socialMedia: 'Соціальні медіа',
    coaching: 'Коучинг',
    ecommerce: 'Магазин',
    healthAndFitness: "Здоров'я та фітнес",
    beautyWellness: 'Краса та добробут',
  },
  billing: {
    back: 'Назад',
    findPlan: 'Оберіть план для себе',
    changeAnytime: 'Ви можете змінити його в будь-який час.',
  },
  field: {
    fullName: "Повне ім'я",
    username: "ім'я користувача",
    addValue: 'Додати значення',
    newValue: 'Нове значення',
    placeholderDefault: 'Текст, числа, символи і т.д.',
    addInstagramUsername: 'Додати Instagram',
    nameDefault: 'Іван',
    enterYourLink: 'Введіть ваше посилання',
    searchImage: 'Пошук зображення',
    pasteLink: 'Вставити посилання',
    pasteLinkTip: 'Додайте посилання на будь-який сайт',
    searchGIFs: 'Пошук GIFs',
    searchIcons: 'Пошук іконок',
    searchVideo: 'Пошук відео',
    search: 'Пошук',
    insertURL: 'Вставити URL',
    writeYourDescription: 'Введіть ваш опис',
    headerCTAbutton: 'Хедер, кнопка CTA',
    enterTitle: 'Введіть заголовок',
    enterDescription: 'Введіть опис',
    enterURL: 'Введіть URL',
  },
  tooltip: {
    addImage: 'Додати зображення',
    labelModalTitle: 'Налаштування мітки',
    addLabel: '+ Додати мітку',
    label: 'Мітка',
    labelCaption: 'Введіть мітку',
    labelText: 'Текст мітки',
    labelTextCaption: 'Введіть текст мітки',
    labelTextPlaceholder: 'Мітка',
    labelUrl: 'URL мітки',
    labelUrlCaption: 'Введіть URL мітки',
    labelUrlPlaceholder: 'https://example.com',
    noLabel: 'Без мітки',
    colorFrom: 'Колір від',
    colorTo: 'Колір до',
    highlight: 'Підсвітити',
    firstName: "Ім'я",
    firstNameCaption: "Введіть ваше ім'я",
    lastName: 'Прізвище',
    lastNameCaption: 'Введіть ваше прізвище',
    jobTitle: 'Посада',
    jobTitleCaption: 'Введіть вашу посаду',
    organization: 'Організація',
    organizationCaption: 'Введіть вашу організацію',
    email: 'Електронна пошта',
    emailCaption: 'Введіть вашу електронну пошту',
    workPhone: 'Робочий телефон',
    workPhoneCaption: 'Введіть ваш робочий телефон',
    mobilePhone: 'Мобільний телефон',
    mobilePhoneCaption: 'Введіть ваш мобільний телефон',
    website: 'Вебсайт',
    websiteCaption: 'Введіть ваш вебсайт',
    information: 'Інформація',
    informationCaption: 'Введіть вашу інформацію',
    streetAddress: 'Вулиця',
    streetAddressCaption: 'Введіть вашу вулицю',
    city: 'Місто',
    cityCaption: 'Введіть ваше місто',
    state: 'Область',
    stateCaption: 'Введіть вашу область',
    postalCode: 'Поштовий індекс',
    postalCodeCaption: 'Введіть ваш поштовий індекс',
    country: 'Країна',
    countryCaption: 'Введіть вашу країну',
    titleColor: 'Колір заголовку',
    titleColorCaption: 'Ви можете змінити колір заголовку',
    fontFamily: 'Шрифт',
    fontFamilyCaption: 'Ви можете змінити шрифт',
    fontSize: 'Розмір шрифту',
    fontSizeLabel: 'Розмір шрифту мітки',
    fontSizeCaption: 'Ви можете змінити розмір шрифту',
    fontSelect: 'Шрифт',
    fontSelectCaption: 'Виберіть шрифт',
    imageMargin: 'Відступ зображення',
    profilePicture: 'Зображення профілю',
    profilePictureCaption: 'Змінити ваше зображення профілю',
    pictureSize: 'Розмір зображення',
    pictureSizeCaption: 'Ви можете змінити розмір зображення профілю',
    title: 'Заголовок',
    titleCaption: 'Введіть заголовок',
    blockCaption: 'Введіть назву блоку',
    titlePageCaption: 'Змінити заголовок вашої сторінки',
    templates: 'Шаблони',
    templatesCaption: 'Виберіть будь-який шаблон для вашої сторінки',
    myTemplates: 'Мої шаблони',
    myTemplatesEmpty: 'У вас ще немає шаблонів. Збережіть поточний дизайн сторінки, щоб використати його потім.',
    saveAsTemplate: 'Зберегти як шаблон',
    saveCurrentAsTemplate: 'Зберегти поточний як шаблон',
    templateSaved: 'Шаблон збережено',
    templateApplied: 'Шаблон застосовано',
    templateKind: 'Що включити',
    publish: 'Опублікувати',
    unpublish: 'Зробити приватним',
    templatePublished: 'Шаблон опубліковано',
    templateUnpublished: 'Шаблон знято з публікації',
    discoverTemplates: 'Шаблони спільноти',
    discoverSubtitle: 'Безкоштовні шаблони, опубліковані іншими творцями UniLink.',
    discoverEmpty: 'Поки що немає публічних шаблонів — стань першим, хто опублікує.',
    pricing: 'Ціна',
    background: 'Фон',
    backgroundColor: 'Колір фону',
    textBackground: 'Фон тексту',
    textBackgroundCaption: 'Виберіть колір фону тексту',
    textColor: 'Колір тексту',
    textColorCaption: 'Виберіть колір тексту',
    gradientBackground: 'Градієнтний фон',
    gradientColor: 'Колір градієнта',
    BackgroundType: 'Тип фону',
    backgroundSource: 'Джерело фону',
    backgroundSourceCaption: 'Виберіть джерело фону',
    backgroundStyle: 'Стиль фону',
    backgroundStyleCaption: 'Виберіть стиль фону',
    backgroundStylesNormal: 'Звичайний',
    backgroundStylesGlass: 'Скляний',
    backgroundStylesOutline: 'Контурний',
    backgroundTypeCaption: 'Змінити тип фону',
    color: 'Колір',
    colorTooltip: 'Ви можете змінити колір',
    backgroundOpacityTooltip: 'Перетягніть повзунок, щоб встановити прозорість фону',
    backgroundBlur: 'Розмиття фону',
    backgroundBlurCaption: 'Змінити розмиття фону',
    backgroundBrightness: 'Яскравість фону',
    backgroundBrightnessCaption: 'Перетягніть повзунок, щоб розмити яскравість фону',
    backgroundContrast: 'Контраст фону',
    backgroundContrastCaption: 'Перетягніть повзунок, щоб змінити контраст фону',
    color1: 'Колір 1',
    color2: 'Колір 2',
    colorCaption: 'Виберіть колір вашої сторінки',
    gradient: 'Градієнт',
    image: 'Картинка',
    photo: 'Фото',
    gif: 'GIF',
    animation: 'Анімація',
    video: 'Відео',
    hexColor: 'Hex колір',
    direction: 'Напрямок',
    gradientDirection: 'Напрямок градієнту',
    directionCaption: 'Перетягніть повзунок, щоб установити напрямок градієнта',
    offset: 'Відступ',
    gradientOffset: 'Зсув градієнту',
    offsetCaption: 'Змінити відступ, щоб встановити зміщення градієнта',
    backgroundDarkness: 'Затемення фону',
    backgroundDarknessCaption: 'Перетягніть повзунок, щоб затемнити фонове зображення',
    uploadVideo: 'Завантажити відео',
    uploadFile: 'Завантажити файл',
    uploadVideoCaption: 'Відео на фоні вашої сторінки',
    linkToVideo: 'Посилання на відео',
    linkToVideoCaption: 'Додати посилання на відео',
    videoWithSound: 'Відео зі звуком',
    videoWithSoundCaption: 'Відтворення відео зі звуком',
    fonts: 'Шрифти',
    fontWeight: 'Товщина шрифту',
    fontWeightCaption: 'Натисніть щоб обрати ваш варіант',
    preloader: 'Прелоадер',
    preview: 'Попередній перегляд',
    hideLogo: 'Приховати логотип UniLink',
    cover: 'Зображення',
    coverCaption: 'Змінити обкладинку',
    coverCaptionHeader: 'Додати зображення або відео до обкладинки',
    pageNavigation: 'Навігація сторінок',
    websiteNavigation: 'Навігація веб-сайту',
    backgroundOpacity: 'Прозорість фону',
    backgroundOpacityCaption: 'Змінити прозорість фону',
    borderRadius: 'Радіус кутів',
    borderRadiusCaption: 'Перетягніть повзунок, щоб задати радіус кутів',
    heightTabs: 'Висота вкладок',
    heightTabsCaption: 'Перетягніть повзунок, щоб задати висоту вкладок',
    backgroundShadow: 'Тінь фону',
    backgroundShape: 'Форма фону',
    backgroundBorder: 'Грані фону',
    opacity: 'Прозорість',
    opacityCaption: 'Перетягніть повзунок, щоб змінити прозорість',
    shape: 'Форма',
    shapeCaption: 'Змінити форму',
    text: 'Текст',
    textCaption: 'Змінити текст',
    textSize: 'Розмір тексту',
    textSizeCaption: 'Змінити розмір тексту',
    additionalText: 'Додатковий текст',
    username: "Ім'я користувача",
    currency: 'Валюта',
    language: 'Мова',
    timeZone: 'Часовий пояс',
    websiteNiche: 'Напрямок сайту',
    websiteNicheCaption: 'Змінити напрямок сайту',
    renameCaption: 'Перейменувати блок',
    description: 'Опис',
    descriptionCaption: 'Введіть опис',
    actionButton: 'Кнопка дії',
    actionButtonCaption: 'Кнопка CTA закликає відвідувачів до дії',
    animationDirection: 'Напрямок анімації',
    animationDirectionCaption: 'Оберіть напрямок анімації',
    buttonTitle: 'Заголовок кнопки',
    buttonTitleCaption: 'Змінити заголовок кнопки',
    buttonUrl: 'Посилання кнопки',
    buttonUrlCaption: 'При натисканні на кнопку, відкриється нове вікно',
    imageSize: 'Розмір зображення',
    imageSizeCaption: 'Перетягніть повзунок, щоб змінити розмір зображення',
    view: 'Вигляд',
    viewCaption: 'Змінити вигляд',
    margin: 'Зовнішній відступ',
    marginCaption: 'Змінити відступ зверху та знизу елементу',
    separateTopBottom: 'Верх / Низ',
    padding: 'Внутрішній відступ',
    paddingCaption: 'Змінити відступ зверху та знизу елементу',
    fullWidth: 'На весь екран',
    lineHeight: 'Висота рядка',
    lineHeightCaption: 'Змінити висоту рядка',
    button: 'Кнопка',
    titleSize: 'Розмір заголовку',
    titleSizeCaption: 'Змінити розмір заголовку',
    titleLineHeight: 'Висота заголовку',
    titleLineHeightCaption: 'Налаштуйте висоту рядка заголовка, щоб додати до тексту більше дизайнерських рішень',
    layout: 'Макет',
    layoutCaption: 'Оберіть вигляд хедеру, який вам довподоби',
    layoutAlign: 'Розміщення макету',
    alignText: 'Розміщення тексту',
    align: 'Розміщення',
    alignCaption: 'Змінити розміщення',
    position: 'Позиція',
    positionCaption: 'Виберіть позицію',
    width: 'Ширина',
    widthCaption: 'Виберіть ширину вашого банеру',
    nameHeader: 'Ім`я',
    nameCaption: 'Введіть ім`я вашого профайлу',
    shortBio: 'Короткий опис',
    shortBioCaption: 'Введіть короткий опис вашого облікового запису',
    externalLink: 'Зовнішнє посилання',
    externalLinkCaption: 'Введіть зовнішнє посилання на ваш обліковий запис',
    location: 'Місцезнаходження',
    locationCaption: 'Введіть ваше місцезнаходження',
    locationMap: 'Карта розташування',
    locationMapCaption: 'Введіть посилання вашого місцезнаходження',
    rightIcon: 'Іконка праворуч',
    rightIconCaption: 'Ця іконка з`явиться на кнопці праворуч',
    buttons: 'Кнопки',
    buttonsCaption: 'Додати кнопку дії',
    nameLogo: 'Логотип імені',
    nameLogoCaption: 'Завантажити логотип для свого імені',
    buttonText: 'Текст кнопки',
    buttonTextCaption: 'Введіть назву вашої кнопки',
    buttonColor: 'Колір кнопки',
    buttonColorCaption: 'Оберіть колір вашої кнопки',
    buttonColorCTACaption: 'Оберіть колір фону для вашої кнопки дії',
    cartColor: 'Колір кошика',
    cartColorCaption: 'Оберіть колір фону для вашого кошика',
    ctaButton: 'Кнопка дії',
    ctaButtonCaption: 'Цей значок з’явиться на кнопці дії праворуч',
    style: 'Стиль',
    socialIconsStyleCaption: 'Ви можете вибрати стиль ваших соціальних іконок',
    socialIconsShape: 'Форма соціальних іконок',
    socialIconsShapeCaption: 'Ви можете вибрати форму соціальних іконок',
    headerTextColorCaption: 'Ви можете обрати колір тексту вашого заголовку',
    pictureShape: 'Форма зображення',
    pictureShapeCaption: 'Ви можете вибрати форму зображення профілю',
    socialLinks: 'Соціальні посилання',
    socialLinksCaption: 'Додайте кнопки соціальних посилань для швидкого зв’язку між вами та вашими клієнтами в один клік',
    URL: 'URL',
    URLCaption: 'Введіть URL адресу',
    heading: 'Заголовок',
    headingTitle: 'Назва заголовку',
    headingTitleCaption: 'Введіть заголовок',
    headingDescription: 'Опис заголовку',
    headingDescriptionCaption: 'Введіть опис заголовку',
    headingImage: 'Зображення блоку',
    headingImageCaption: 'Завантажте зображення для заголовку',
    headingPosition: 'Позиція заголовку',
    headingInsideBlock: 'В блоку',
    headingOutsideBlock: 'Зовні',
    headingDivider: 'Роздільник заголовку',
    canonicalURL: 'Канонічний URL',
    seo: 'SEO',
    seoCaption: 'Налаштуйте свій продукт за допомогою метатегів SEO',
    themes: 'Теми',
    brandColors: 'Кольори бренду',
    applyBrandColors: 'Застосувати до профілю',
    syncBlocks: 'Синхронізувати всі блоки',
    brandColorsApplied: 'Кольори бренду застосовано',
    generatedPalette: 'Згенерована палітра',
    applying: 'Застосовується...',
    syncing: 'Синхронізація...',
    backgroundType: 'Тип фону',
    palettes: 'Палітри',
    previewTitle: 'Заголовок',
    previewTitleCaption: 'Введіть заголовок попереднього перегляду',
    previewDescription: 'Опис',
    previewDescriptionCaption: 'Введіть опис попереднього перегляду',
    previewButton: 'Текст кнопки',
    previewButtonCaption: 'Введіть текст кнопки попереднього перегляду',
    previewLabel: 'Текст мітки',
    previewLabelCaption: 'Введіть текст мітки попереднього перегляду',
    previewThumbnail: 'Мініатюра',
    previewThumbnailCaption: 'Завантажте мініатюру попереднього перегляду',
  },
  table: {
    clicks: 'Кліки',
    signups: 'Підписки',
    views: 'Перегляди',
    orderNumber: 'Номер замовлення',
    amount: 'Сума',
    credits: 'Кредити',
    invoice: 'Рахунок',
    email: 'Електронна пошта',
    card: 'Картка',
    currency: 'Валюта',
    name: 'Ім’я',
    contact: 'Контакт',
    optIn: 'Згода',
    notes: 'Нотатки',
    address: 'Адреса',
    date: 'Дата',
    action: 'Дія',
    custom: 'Налаштування',
    status: 'Статус',
    tags: 'Теги',
    view: 'Перегляд',
    remove: 'Видалити',
    sendEmail: 'Надіслати електронною поштою',
    details: 'Деталі',
    purchases: 'Покупки',
    order: 'Замовлення',
    money: 'Гроші',
    type: 'Тип',
    orderCode: 'Код замовлення',
  },
  settings: {
    title: 'Налаштування',
    settings: 'налаштування',
    accountSettings: 'Налаштування аккаунта',
    email: 'Email',
    subscription: 'Підписка',
    billingHistory: 'Історія платежів',
    dueTo: 'Діє до',
    subscriptionDueTo: 'Підписка діє до',
    cancelSubscription: 'Скасувати підписку',
    cancelSubscriptionConfirm: 'Ви впевнені, що хочете скасувати підписку?',
    subscriptionCancelled: 'Підписку скасовано. Ваш план залишається активним до кінця поточного платіжного періоду.',
    subscriptionCancelError: 'Не вдалося скасувати підписку. Зверніться до служби підтримки.',
    deleteFirst: 'Назавжди видалити ваш',
    deleteSecond: 'та всі його дані. Цю дію неможливо скасувати.',
    account: {
      title: 'Аккаунт',
      usernameNotAvailable: "Ім'я користувача з таким ім'ям вже існує.",
      setupCustomDomain: 'Налаштування домену',
      subtitle: 'Електронна пошта, платежі, пароль та ключ API',
    },
    profile: {
      title: 'Профіль',
      usernameNotAvailable: "Ім'я користувача недоступне",
      setupCustomDomain: 'Налаштувати власний домен',
      subtitle: 'Керуйте ім’ям користувача, мовою, валютою, часовим поясом',
      category: 'Категорія',
      categoryCaption: 'Введіть категорію вашого профілю',
    },
    aiassistant: {
      title: 'AI Assistant',
      subtitle: 'Налаштуйте свого ШІ помічника для кращих та персоналізованіших відповідей',
      titleText: 'Допоможіть ШІ зрозуміти, хто ви, щоб отримувати більш релевантні відповіді',
      customAiTitle: 'Користувацькі інструкції',
      customAiPlaceholder: 'Додайте будь-які конкретні інструкції для ШІ...',
      customAiDescription: 'Ці інструкції будуть застосовані до кожної розмови з ШІ',
      nicknameTitle: 'Як ШІ має вас називати?',
      nicknamePlaceholder: 'Нікнейм',
      titleBio: 'Біографія/ Опис',
      bioPlaceholder: 'Розкажіть нам трохи про себе...',
      occupation: 'Ким ти працюєш?',
      occupationPlaceholder: 'наприклад, студент-інженер в Університеті КПІ',
      aboutYouTitle: 'Про вас',
      aboutYouTooltip: 'Розкажіть своєму ШІ-помічнику трохи про себе',
      locationTitle: 'Локація',
      locationPlaceholder: 'наприклад, Київ, Україна',
      categoryTitle: 'Категорії',
    },
    notifications: {
      title: 'Сповіщення',
      subtitle: 'Налаштуйте сповіщення про нові імейли від відвідувачів та замовлення',
      text: 'Підключіть месенджери, щоб отримувати сповіщення про імейли та замовлення',
      setUpWebhooks: 'Налаштуйте вебхуки в розділі Вебхуки',
      save: 'Зберегти',
      connect: 'ПІДКЛЮЧИТИ',
      disconnect: 'ВІДКЛЮЧИТИ',
      webhook: 'Вебхук',
      emailSubmit: 'Надсилання email',
      formSubmit: 'Надсилання форми',
      showSubmit: 'Оформлення замовлення у магазині',
      digitalSubmit: 'Замовлення цифрового продукту',
      appointmentSubmit: 'Замовлення запису на консультацію',
      requestSubmit: 'Замовлення послуги',
      donationSubmit: 'Отримення донату',
      email: 'Електронна пошта',
      settings: 'Налаштування',
      cartSubmit: 'Оформлення замовлення',
      linkClick: 'Клік по посиланню',
      contactClick: 'Клік по контакту',
      all: 'Усі',
      updates: 'Оновлення',
      messages: 'Повідомлення',
      opportunities: 'Можливості',
      insights: 'Інформація',
      activity: 'Активності',
      system: 'Система',
      news: 'Новини',
      more: 'Показати більше',
      less: 'Показати менше',
      connectedAccounts: 'Підключені аккаунти',
      addEmailAccount: 'Додати email аккаунт',
    },
    paymentSystem: {
      title: 'Платіжна система',
      subtitle: 'Налаштуйте виплати через Stripe або PayPal',
      text: 'Переглянути комісії за обробку',
      connected: 'Підключено',
      active: 'Активно приймаються платежі на сайті',
      pending: 'В очікуванні',
      disconnect: 'Відключити',
      connect: 'Підключити',
      add: 'Додати',
      ofYourAccount: 'вашого акаунту',
      save: 'Зберегти',
    },
    shop: {
      title: 'Магазин',
      subtitle: 'Налаштування категорій та властивостей',
      label: {
        title: 'Мітки',
        subtitle: 'Додайте мітки до карток товарів',
        addValue: 'Додати значення',
        save: 'Зберегти',
        value: 'Значення',
        enterTitle: 'Введіть заголовок',
        maximum: 'Максимальна кількість значень може бути 5',
        add: 'Додати',
        edit: 'Редагувати',
        labels: 'Мітки',
      },
      category: {
        title: 'Категорії',
        subtitle: 'Додайте категорію до ваших товарів',
        addCategory: 'Додати категорію',
        save: 'Зберегти',
        maximum: 'Максимальна кількість може бути',
      },
      property: {
        title: 'Властивість',
        subtitle: 'Додайте властивість до ваших товарів',
        addProperties: 'Додати властивості',
        properties: 'Властивості',
        type: 'Тип',
        typeTooltip: 'Тип ваших властивостей',
        titleModal: 'Заголовок',
        titleModalTooltip: 'Назва ваших властивостей',
        enterTitle: 'Введіть заголовок',
        value: 'Значення',
        addValue: 'Додати значення',
        maximum: 'Максимальна кількість значень може бути',
        save: 'Зберегти',
        cancel: 'Скасувати',
        remove: 'Видалити',
        addPropertyToItem: 'Додати властивість до товару',
        add: 'Додати',
        edit: 'Редагувати',
        propertiesSmall: 'властивості',
        required: "Обов'язково",
        requiredTooltip: "Встановіть обов'язкові властивості для купівлі",
        selectAll: 'Вибрати всі',
      },
      preorderForm: {
        title: 'Форма передзамовлення',
        subtitle: 'Налаштуйте поля форми передзамовлення',
        fields: 'Поля',
        fieldsTooltip: 'Додати поля до форми передзамовлення',
        required: "Обов'язково",
        submitButton: 'Текст кнопки надсилання',
        redirectUrl: "URL перенаправлення (необов'язково)",
        resultText: 'Текст результату',
        save: 'Зберегти',
        name: 'Ім’я',
        emailAddress: 'Електронна пошта',
        phone: 'Телефон',
        address: 'Адреса',
        comment: 'Коментар',
      },
      shipping: {
        title: 'Доставка',
        subtitle: 'Налаштуйте поля доставки',
        fields: 'Поля',
        fieldsTooltip: 'Додайте поля до форми доставки',
        required: "Обов'язково",
        save: 'Зберегти',
        name: 'Ім’я',
        emailAddress: 'Електронна пошта',
        phone: 'Телефон',
        address: 'Адреса',
        comment: 'Коментар',
        addCustomField: 'Додати власне поле',
        addFormInfo: 'Додати інформацію форми',
        editFormInfo: 'Редагувати інформацію форми',
        type: 'Тип',
        typeTooltip: 'Тип власного поля',
        fieldName: 'Назва поля',
        fieldNameTooltip: 'Назва для власного поля',
        placeholder: 'Заповнювач',
        placeholderTooltip: 'Заповнювач для власного поля',
        delete: 'Видалити',
        update: 'Оновити',
        add: 'Додати',
      },
      delivery: {
        title: 'Способи доставки',
        subtitle: 'Налаштуйте кур’єрську доставку, локальну доставку та самовивіз для вашого магазину.',
        loading: 'Завантаження…',
        inactive: 'неактивний',
        confirmDelete: 'Видалити цей спосіб доставки?',
        category: { shipping: 'Перевізник', localDelivery: 'Локальна доставка', selfPickup: 'Самовивіз' },
        rateType: { free: 'Безкоштовно', conditionalFree: 'Умовно безкоштовно', flatRate: 'Фіксована ціна', customRates: 'Власні тарифи', carrierApi: 'API перевізника' },
        carrier: { custom: 'Інший перевізник' },
        add: { shipping: 'Додати Перевізника', localDelivery: 'Додати Локальну доставку', selfPickup: 'Додати Самовивіз' },
        actions: { edit: 'Редагувати', delete: 'Видалити', save: 'Зберегти', cancel: 'Скасувати' },
        fields: {
          name: 'Назва',
          namePh: 'Напр., Звичайна доставка',
          description: 'Опис',
          isActive: 'Активний',
          estimatedDays: 'Орієнтовно днів',
          currency: 'Валюта',
          countryCodes: 'Країни (CSV)',
          carrier: 'Перевізник',
          rateType: 'Тип тарифу',
          flatPrice: 'Фіксована ціна',
          freeThreshold: 'Безкоштовно від (subtotal)',
          fallbackPrice: 'Ціна, якщо менше порогу',
          customRates: 'Власні рядки тарифу',
          senderCity: 'Місто відправника',
          senderCityRef: 'ID міста відправника',
          pickupInstructions: 'Інструкції для самовивозу',
          pickupCharge: 'Доплата за самовивіз',
          askPickupDateTime: 'Питати дату/час на checkout',
        },
        rateRow: { subtotal: 'За сумою кошика', weight: 'За вагою (г)', min: 'Від', max: 'До', price: 'Ціна', add: 'Додати рядок' },
      },
      legal: {
        title: 'Юридична інформація',
        subtitle: 'Договір-оферта, політика конфіденційності, повернення — клієнт побачить це на checkout.',
        loading: 'Завантаження…',
        empty: 'Поки немає документів.',
        inactive: 'неактивний',
        required: "обов'язковий",
        confirmDelete: 'Видалити цей документ?',
        addNew: '+ Додати документ',
        types: {
          terms: 'Договір-оферта',
          privacy: 'Політика конфіденційності',
          returns: 'Політика повернення',
          shipping: 'Політика доставки',
          cookies: 'Cookie Policy',
          custom: 'Власний',
        },
        fields: {
          title: 'Заголовок',
          titlePh: 'Напр., Договір-оферта',
          type: 'Тип документа',
          content: 'Контент',
          contentPh: 'Введіть текст документа…',
          isActive: 'Активний',
          requireAcceptance: "Обов'язково погодити на checkout",
        },
        actions: { edit: 'Редагувати', delete: 'Видалити', save: 'Зберегти', cancel: 'Скасувати' },
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Налаштуйте вашу сторінку за допомогою мета-тегів SEO',
      titleText: 'Заголовок',
      titlePlaceholder: 'Введіть заголовок сторінки',
      description: 'Опис',
      descriptionPlaceholder: 'Введіть опис сторінки',
      favicon: 'Favicon',
      uploadFavicon: 'Завантажити favicon',
      imagePreview: 'Попередній перегляд зображення',
      useCustom: 'Використовувати власне зображення',
      save: 'Зберегти',
      visualise: 'Візуалізуйте, як буде виглядати попередній перегляд вашого сайту в Google',
      inMessengers: 'У месенджерах',
      inSocial: 'У соціальних мережах',
      searchEngine: 'Пошукові системи',
      googleIndexable: 'Дозволити Google індексувати сторінку',
      sitemap: {
        title: 'Sitemap',
        entryHint: 'Керуйте індексацією сторінок і продуктів пошуковими системами.',
        setupLink: 'налаштувати',
        mainEntry: 'Індексувати вебсайт',
        subtitle: 'Оберіть, які сторінки пошуковики мають індексувати. Вимкнені сторінки отримають тег noindex та зникнуть із sitemap.',
        mainPage: 'Головна сторінка профілю',
        pagesSection: 'Сторінки',
        pagesHint: 'Перемикайте індексацію для кожної додаткової сторінки сайту.',
        noPages: 'Поки що немає додаткових сторінок.',
        productsSection: 'Продукти',
        productsHint: 'Перемикайте індексацію для окремих сторінок продуктів.',
        noProducts: 'Поки що немає продуктів.',
        postsSection: 'Пости',
        postsHint: 'Перемикайте індексацію для окремих постів.',
        noPosts: 'Поки що немає постів.',
        blogSection: 'Статті блогу',
        blogHint: 'Перемикайте індексацію для окремих статей блогу.',
        noArticles: 'Поки що немає статей блогу.',
        loadMore: 'Завантажити ще',
        loading: 'Завантаження…',
      },
    },
    analytics: {
      title: 'Аналітика',
      subtitle: 'Інтеграція Facebook Pixel, Google Analytics та UTM параметрів',
      facebookTooltip: 'Підключіть Facebook для відображення аналітики',
      googleAnalyticsTooltip: 'Google Analytics дозволяє вимірювати ваш рекламний ROI, а також відстежувати всі ваші посилання.',
      googleTagManagerTooltip: 'Google Tag Manager дозволяє налаштовувати та миттєво розгортати теги на вашому вебсайті',
      tikTokPixelTooltip: 'TikTok Pixel - це потужний інструмент вимірювання, який відстежує вплив ваших реклам в TikTok на ваш вебсайт',
      pinterestTag: 'Pinterest тег',
      pinterestTagTooltip:
        'Pinterest таг - це фрагмент коду, який ви додаєте на свій вебсайт, щоб Pinterest міг відстежувати відвідувачів вашого сайту, а також дії, які вони виконують на вашому сайті після перегляду вашої реклами в Pinterest.',
      tag: 'тег',
      headerTagTooltip: "Вставте тег, який з'являється в заголовку вашого вебсайту",
      bodyTagTooltip: "Вставте тег, який з'являється в тілі вашого вебсайту",
      utmParameters: 'UTM параметри',
      utmParametersTooltip: 'Збирайте дані кампанії за допомогою користувацьких URL. Додайте параметри до URL для ідентифікації кампаній, які направляють трафік.',
      makeAnalytics: 'Налаштуйте Google Analytics для показу трафіку UniLink як соціального',
      the: 'Параметр',
      campaign: 'кампанії',
      parameter: 'встановлюється динамічно з заголовка кожного посту або посилання',
      save: 'Зберегти',
    },
    customDomain: {
      title: 'Власний домен',
      subtitle: 'Підключіть власний домен до вашої сторінки',
      titleTooltip: 'Додати власний домен',
      save: 'Зберегти',
      connect: 'Підключитися',
      connecting: 'Підключення',
      instructions: 'Інструкції',
      submit: 'Надіслати',
      submitting: 'Надсилання...',
      enterDomain: 'Введіть ваш домен',
      domainPlaceholder: 'your-domain.com',
      steps: {
        submitting: 'Надсилання запиту',
        validation: 'Перевірка домену',
        certificate: 'Видача сертифіката',
        complete: 'Завершено',
      },
      txtRecord: {
        title: 'TXT-запис',
        description: 'Додайте наступний TXT-запис у налаштуваннях DNS:',
        verifyButton: 'Перевірити TXT-запис',
        verifying: 'Перевірка...',
        verified: 'TXT-запис підтверджено',
      },
      cnameRecord: {
        title: 'CNAME-запис',
        description: 'Додайте наступний CNAME-запис у налаштуваннях DNS:',
        verifyButton: 'Перевірити CNAME-запис',
        verifying: 'Перевірка...',
        verified: 'CNAME-запис підтверджено',
      },
      dnsTable: {
        type: 'Тип',
        host: 'Хост',
        value: 'Значення',
        ttl: 'TTL',
        copy: 'Копіювати',
        copied: 'Скопійовано!',
      },
      provisioning: {
        title: 'SSL-сертифікат видається...',
        description: 'Це може зайняти кілька хвилин. Зачекайте, будь ласка.',
        timeout: 'Видача сертифіката триває довше, ніж очікувалося. Перевірте пізніше.',
      },
      complete: {
        title: 'HTTPS успішно увімкнено для вашого домену.',
        connected: 'Підключено',
      },
      failed: {
        title: 'Не вдалося підключити домен',
        tryAgain: 'Спробувати ще раз',
      },
      rootDomainWarning: 'Кореневі домени вимагають, щоб ваш DNS-провайдер підтримував CNAME flattening (наприклад, Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Відключити домен',
        message: 'Ви впевнені, що хочете відключити цей домен? Ваш сайт більше не буде доступним за цим доменом.',
        confirm: 'Відключити',
        cancel: 'Скасувати',
      },
    },
    webhooks: {
      title: 'Вебхуки',
      subtitle: 'Автоматизуйте ваш акаунт за допомогою функцій Webhooks та Autopilot',
      webhook: 'Вебхук',
      webhookTooltip: 'Додати вебхук',
      send: 'Надсилати події на сторонній вебсайт',
      webhookUrl: 'URL вебхука (POST запит)',
      error: 'Введіть правильне посилання',
      save: 'Зберегти',
      enableWebhooks: 'Увімкнути вебхуки',
      enableDescription: 'POST-запити при вибраних подіях',
      endpointUrl: 'URL ендпоінта',
      endpointTooltip: 'URL, який отримуватиме POST-запити при настанні вибраних подій',
      endpointPlaceholder: 'https://example.com/api/webhook',
      events: 'Події',
      selectAll: 'Вибрати всі',
      deselectAll: 'Зняти вибір',
      filterPlaceholder: 'Фільтрувати події...',
      all: 'Усі',
      none: 'Жодного',
      active: 'Активно',
      inactive: 'Неактивно',
      categories: {
        submissions: 'Надсилання',
        engagement: 'Залученість',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Підписка в шапці',
        SubmitHeaderMessage: 'Повідомлення в шапці',
        SubmitDataCollect: 'Збір даних',
        SubmitForm: 'Надсилання форми',
        SubmitShop: 'Замовлення в магазині',
        SubmitShopPreorder: 'Передзамовлення в магазині',
        SubmitDigital: 'Цифровий продукт',
        SubmitAppointment: 'Запис на прийом',
        SubmitService: 'Замовлення послуги',
        SubmitEvent: 'Реєстрація на подію',
        SubmitCourse: 'Запис на курс',
        SubmitDonation: 'Пожертва',
        SubmitMembership: 'Членство',
        SubmitBlog: 'Купівля блогу',
        SubmitCoupon: 'Використано купон',
        SubmitTip: 'Чайові',
        SubmitLink: 'Купівля посилання',
        SubmitProductMessage: 'Запитання про продукт',
        SubmitPodcast: 'Купівля подкасту',
        SubmitBooking: 'Бронювання',
        SubmitRental: 'Оренда',
        SubmitSingleProduct: 'Окремий продукт',
        SubmitDiscount: 'Замовлення зі знижкою',
        SubmitListing: 'Запит на оголошення',
        SubmitUnlock: 'Розблокування контенту',
        SubmitChatAi: 'Повідомлення AI-чату',
        ClickLink: 'Клік по посиланню',
        ClickContact: 'Клік по контакту',
        AddToCart: 'Додати в кошик',
        AddToCartSingleProduct: 'Один товар у кошик',
        AddToWishlist: 'Додати в список бажань',
        InitiateCheckout: 'Розпочати оформлення',
        DownloadFile: 'Завантаження файлу',
        DownloadMusic: 'Завантаження музики',
        CopyCoupon: 'Скопіювати купон',
        CopyDiscount: 'Скопіювати знижку',
        QR_ScanQrCode: 'Сканування QR-коду',
        VisitPage: 'Відвідування сторінки',
      },
    },
    sensitive: {
      title: 'Чутливий матеріал',
      subtitle: 'Показуйте попередження про конфіденційний вміст перед показом вашого сайту',
    },
    socialIntegration: {
      title: 'Інтеграція соціальних мереж',
      subtitle: 'Керуйте своїми інтеграціями в Instagram, TikTok',
      connectInstagram: 'Підключити інстаграм',
    },
    emailIntegration: {
      title: 'Інтеграція електронної пошти',
      subtitle: 'Передайте електронні адреси своїх відвідувачів до MailChimp, Reply',
      emailCaption: 'Додайте інтеграцію, щоб передавати адреси пошт підписників до MailChimp',
      mailChimp: 'Інтеграції MailChimp',
      selzy: 'Selzy інтеграція',
      selzyCaption: 'Додайте API-ключ, щоб передавати адреси пошт підписників до Selzy',
      sendPulse: 'SendPulse інтеграція',
      sendPulseCaption: 'Додайте API-ключ, щоб передавати адреси пошт підписників до Sendpulse',
      reply: 'Reply інтеграція',
      replyCaption: 'Додайте ключ API для передачі електронних адрес ваших підписників до',
      integrations: 'інтеграції',
    },
    calendarIntegration: {
      title: 'Інтеграції календаря',
      subtitle: "Під'єднайте ваші календарні сервіси",
      calendly: 'Calendly',
      calendlyDescription: "Під'єднайте Calendly для синхронізації типів подій та доступності",
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: "Під'єднайте Google Calendar для синхронізації подій та створення Google Meet посилань",
      zoom: 'Zoom',
      zoomDescription: "Під'єднайте Zoom для автоматичного створення посилань на зустрічі",
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Автоматичне створення Google Meet посилань (потребує Google Calendar)',
    },
    storage: {
      title: 'Зберігання',
      subtitle: 'Зберігайте порядок відвідувачів у Google Spreadsheet',
      storageCaption: 'Додайте інтеграцію, щоб зберегти всі замовлення клієнта в Google Spreadsheet',
      emailSignup: 'Реєстрація електронною поштою',
      emailSignupsCaption: 'Виберіть таблицю для збереження реєстрації електронної пошти',
      formSignups: 'Реєстрація формою',
      forSignupsCaption: 'Виберіть таблицю для збереження заявок',
      shopOrders: 'Замовлення в магазині',
      shopOrderCaption: 'Виберіть таблицю для збереження замовлень в магазині',
      disconnect: 'Відключити електронну таблицю',
      storageUsage: 'Використання сховища',
      of: 'з',
      uses: 'Цей додаток використовує',
      space: 'вашого дискового простору',
      view: 'переглянути деталі',
      noItems: 'Немає елементів',
      files: 'Файли',
      images: 'Зображення',
      videos: 'Відео',
      audio: 'Аудіо',
      settings: 'налаштування',
    },
  },
  productStore: {
    title: 'Показати вкладку магазину на вашому link-in-bio',
    subtitle: 'Ваш магазин наразі приховано.',
  },
  sections: {
    splashScreen: {
      title: 'Вспливаюче вікно',
      subtitle: 'Відображається під час завантаження сторінки',
    },
    promo: {
      title: 'Промобар',
      subtitle: 'Рекламний рядок вгорі вашого сайту',
      masterPromoMessage: 'Головний промобар увімкнений. Якщо ви бажаєте створити окремий промобар лише для цієї сторінки, спочатку потрібно вимкнути головний.',
      titlePlaceholder: 'Вітаю на моєму вебсайті!',
      switcherIsMasterPromobar: 'Показувати на всіх сторінках',
    },
    contact: {
      title: 'Контакти',
      subtitle: 'Надайте зручний спосіб спілкування з вами',
      caption: 'Додайте кнопки месенджера для швидкого зв’язку між вами та вашими клієнтами в один клік',
      tooltip: 'Контакти дозволяють користувачам спілкуватися з вами напряму. Додайте свій телефон, електронну пошту, месенджер або місцезнаходження',
      addNewContact: 'Додати новий контакт',
      addContact: 'Додати контакт',
      chooseContact: 'Вибрати тип контакту',
      enterLink: 'Введіть посилання на контакт або номер',
      showDetails: 'Показати посилання або номер',
      enterAnyContact: 'Будь ласка додайте контакт',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Передплата',
      subtitle: 'Cтворіть безкоштовну або платну підписку на ваш контент',
      addNewTier: 'Додати нову підписку',
      editTier: 'Редагувати підписку',
      name: 'Назва',
      nameCaption: 'Відредагуйте назву підписки',
      price: 'Вартість',
      priceCaption: 'Відредагуйте вартість підписки',
      month: 'місяць',
      image: 'Зображення',
      imageCaption: 'Завантажте зображення для вашого плану',
    },
    pricing: {
      title: 'Меню',
      subtitle: 'Cтворіть меню для ваших послуг',
      add: 'Додати нову позицію',
      edit: 'Редагувати позицію',
      name: 'Назва',
      nameCaption: 'Відредагуйте назву позиції',
      duration: 'Мітка',
      durationCaption: 'Додайте тривалість, вагу, тощо',
      category: 'Категорія',
      categoryCaption: 'Додайте нову категорію',
      price: 'Вартість',
      priceCaption: 'Відредагуйте вартість позиції',
      month: 'місяць',
      image: 'Зображення',
      imageCaption: 'Завантажте зображення для вашої позиції',
    },
    subscribe: {
      dataCollectTitle: 'Збір даних',
      title: 'Підписка',
      subtitle: 'Збирайте електронні адреси або номери телефонів своїх відвідувачів',
      instructionsMessage: 'Додайте поле для підписки за електронною поштою на вашу сторінку, щоб ваші відвідувачі могли легко підписатися!',
      instructionsLink: 'Передавайте листи в MailChimp для проведення маркетингових кампаній.',
      sectionHeaderCaption: 'Підпишіться на мої оновлення',
      collecting: 'Збір даних',
      collectingCaption: 'Виберіть тип даних',
      addDataToCollect: 'Додати дані для збору',
      email: 'Електронна пошта',
      enterEmail: 'Введіть електронну пошту',
      thanksForEmail: 'Дякуємо за вашу електронну пошту',
      phone: 'Телефон',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Додати оновлені посилання',
      placeholder: 'Плейсхолдер',
      placeholderCaption: 'Введіть текст плейсхолдера',
      button: 'Кнопка',
      buttonCaption: 'Текст, який спонукає відвідувача ввести електронну пошту (знижка 10%, підписатися зараз, завантажити файл тощо)',
      submitButton: 'Кнопка підтвердження',
      enterButton: 'Кнопка надсилання',
      thanksMessage: 'Повідомлення після підтвердження',
      thanksMessageCaption: 'Повідомлення подяки вашим підписникам',
      resultAction: 'Дія (після відправки)',
      resultActionCaption: 'Дія після заповнення форми',
      sendAnEmail: 'Надіслати електронний лист',
      downloadFile: 'Завантажити файл',
      redirect: 'Перенаправлення',
      messageBody: 'Тіло повідомлення',
      messageBodyCaption: 'Ці дані будуть відправлені на адресу користувача як подарунок за його електронну пошту (купон, посилання на завантаження файлу тощо)',
      integration: 'Інтеграція',
      integrationCaption: 'Додайте відвідувачів до MailChimp, Reply',
      storage: 'Сховище',
      storageCaption: 'Зберігайте відвідувачів у Google Spreadsheet',
      maxSize: 'Ви можете додати тільки три канали',
    },
    text: {
      title: 'Текст',
      subtitle: 'Напишіть що-небудь про себе/компанію',
      trimBio: 'Показати кнопку More',
    },
    header: {
      title: 'Заголовок',
      subtitle: 'Збільшене основне зображення чи відео на вашій сторінці',
      verifiedBadge: 'Верифікаційна галочка',
      showProfilePic: 'Показати фото профілю',
      profilePicRatio: 'Пропорція',
      profilePicRatioSquare: 'Квадрат',
      profilePicRatioLandscape: 'Ландшафт',
      profilePicRatioPortrait: 'Портрет',
      namePlaceholder: 'Ваше ім`я',
      shortBioPlaceholder: 'Мій короткий опис',
      externalLinkPlaceholder: 'Посилання',
      locationPlaceholder: 'Місто',
      addSocial: '+ Додати посилання',
      addCover: '+ Додати зображення',
      addButton: '+ Додати кнопку',
      addText: '+ Додати текст',
      addLabel: '+ Додати мітку',
      subtitleName: 'Налаштуйте вигляд свого імені',
      subtitleShortBio: 'Налаштуйте свій короткий опис',
      shortBioSize: 'Розмір короткого опису',
      subtitleShortBioSize: 'Ви можете змінити розмір короткого опису',
      subtitleLocation: 'Установити місто/країну для навігації відвідувачів до певного місця',
      headerCoverWarningMessage: 'Ваш браузер не підтримує тип цього відео',
      headerCoverTitle: 'Встановіть зображення над заголовком',
      coverHeight: 'Висота зображення',
      subtitleCoverHeight: 'Ви можете змінити висоту зображення',
      coverDarkness: 'Затемнення зображення',
      subtitleCoverDarkness: 'Перетягніть повзунок щоб затемнити зображення',
      nameSize: 'Розмір ім`я',
      subtitleNameSize: 'Ви можете змінювати розмір свого ім`я',
      positionText: 'Позиція імені',
      subtitlePositionName: 'Перетягніть повзунок, щоб задати позицію імені',
      positionContent: 'Позиція вмісту',
      subtitlePositionContent: 'Задайте позицію для біо, посилання, локації',
      coverText: 'Текст на обкладинці',
      subtitleCoverText: 'Додати текст до обкладинки',
      position: 'Положення кнопки',
      subtitlePosition: 'Перетягніть повзунок щоб встановити положення кнопки',
      buttonCover: 'Кнопка на обкладинці',
      subtitleButtonCover: 'Додайте кнопку до обкладинки, вибравши дію',
      subtitleFollow: 'Кнопка «Слідкувати» дозволяє користувачам стежити за вашими новинами',
      buttonOpacity: 'Перетягніть повзунок, щоб змінити прозорість кнопки',
      subtitleCart: 'Зображення кошика для зручності покупок',
      subtitleDirect: 'Швидка кнопка для переходу відвідувачів до месенджерів',
      subtitleCTAButton: 'Кнопка (заклик до дії), яка спонукає користувача натиснути',
      subtitleSocialLinks: 'Посилання на соцмережі',
      chooseSocialLink: 'Оберіть соціальне посилання',
      alignSocialLink: 'Вирівнювання соціальних посилань',
      enterYourSocialLink: 'Введіть своє соціальне посилання',
      blockShadow: 'Блок додавання тіні',
      activeButtonPosition: 'Положення активної кнопки',
      gradientColor: 'Колір градієнта',
      bottomGradient: 'Нижній градієнт',
      autoGradient: 'Авто',
      customGradient: 'Вибрати',
      uploadLogo: 'Завантажити логотип',
      customBackground: 'Додати обраний фон',
      headingLabel: 'Мітка заголовка',
      customizeLabel: 'Налаштуйте зовнішній вигляд підпису заголовка',
      labelText: 'Текст підпису',
      enterLabelText: 'Введіть текст для підпису заголовка',
    },
  },
  billingHistory: {
    title: 'Історія платежів',
    invoices: 'Рахунки',
    messageText: 'У вас ще немає історії платежів.',
  },
  migrate: {
    title: 'У вас є LinkTree або Taplink?',
    text: 'Вставте посилання та перейдіть на UniLink лише в один клік!',
    button: 'Перей̆ти на UniLink',
  },
  pages: {
    title: 'Сторінки',
    addPage: 'Додати сторінку',
    addNewPage: 'Додати нову сторінку',
    deleteTitle: 'Ви впевнені, що хочете видалити цю сторінку?',
    managePage: 'Керування сторінками',
    empty: 'Ця сторінка немає блоків.',
    dragAndDrop: 'Перетягніть сторінки для зміни порядку.',
    pageNavigation: 'Налаштування навігації сторінки',
    goToDesign: 'Перейти до налаштування дизайну',
    viewArchive: 'Переглянути архів',
    archivedBlocks: 'Заархівовані блоки',
    noArchivedBlocks: 'Тримайте адмін-панель чистою та зручною, архівуючи блоки, які зараз не використовуєте.',
    archiveAllUnpublished: 'Архівувати всі неопубліковані блоки',
    restore: 'Відновити',
    permanentDelete: 'Видалити назавжди',
  },
  analytics: {
    lifeTimeAnalytics: 'Історія переглядів',
    impressions: 'Перегляди',
    impressionsText: 'Перегляди за обраний період',
    clicks: 'Кліки',
    clicksText: 'Кількість кліків за обраний період',
    signUps: 'Зареєстровані',
    signUpsText: 'Зареєстровані за обраний період',
    totalInteractions: 'Взаємодії',
    totalInteractionsText: 'Усі кліки та реєстрації через форми за обраний період',
    engagementRate: 'Рівень залученості',
    engagementRateText: 'Частка переглядів профілю, що призвели до взаємодії',
    visitor: 'Відвідувачі',
    country: 'Країна',
    countries: 'Країни',
    linkClicks: 'Кількість кліків',
    content: 'Контент',
    views: 'Перегляди',
  },
  aiInsights: {
    title: 'AI Рекомендації',
    generate: 'Аналізувати профіль',
    description: 'Отримайте AI-рекомендації для покращення ефективності вашого профілю.',
    analyzing: 'Аналізую ваш профіль...',
    refresh: 'Оновити',
    action: 'Дія',
  },
  post: {
    subscriptionTypePlaceholder: 'Доступно для підписок PRO та вище',
    postButtonText: 'Опублікувати',
    newPostPlaceholder: 'Напишіть щось',
    free: 'Free',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'У вас ще немає постів',
    editPost: 'Редагувати пост',
  },
  preview: {
    buy: 'Купити',
    connect: 'Підключити',
  },
  activeButton: {
    initialText: 'Вебсайт',
    inputPlaceholder: 'Пошук дій...',
    existing: 'Існуючий',
    redirect: 'Перенаправлення',
    scroll: 'Прокрутка',
    title: 'Активна Кнопка',
    modalTitle: 'Дія активної кнопки',
    subtitle: 'Кнопка, яка мотивує користувача здійснити дію',
    next: 'Далі',
    save: 'Зберегти',
    opensALinkFromLinksBlock: 'Відкриває посилання з блоку Посилання',
    url: 'URL',
    opensAWebsite: 'Відкриває вебсайт',
    openInApp: 'Відкрити в застосунку',
    addAction: 'Додати Дію',
    actionTitle: 'Дія',
    actionCaption: 'Редагувати тип дії',
    chooseOption: 'Виберіть опцію',
    tellPeople: 'Розкажіть людям, як взаємодіяти з кнопкою дії',
    urlRedirect: 'Перенаправлення за URL',
    customUrl: 'Користувацький URL',
    customUrlText: 'Відкриває вебсайт',
    links: 'Посилання',
    linksText: 'Відкриває посилання з блоку Посилання',
    downloadDocument: 'Завантажити документ',
    sendEmail: 'Надіслати email',
    opensEmailClient: 'Відкриває поштовий клієнт',
    phoneCall: 'Телефонний дзвінок',
    initiatesPhoneCall: 'Ініціює телефонний дзвінок',
    navigation: 'Навігація',
    openPage: 'Відкрити Сторінку',
    opensInternalPage: 'Відкриває внутрішню сторінку',
    openPageText: 'Відкриває внутрішню сторінку',
    openProduct: 'Відкрити Продукт',
    openProductText: 'Відкриває сторінку продукту з магазину',
    openBlog: 'Відкрити блог',
    opensBlogPageFromStore: 'Відкриває сторінку блогу з магазину',
    openBlock: 'Відкрити блок',
    opensContentBlock: 'Відкриває блок вмісту',
    openItem: 'Відкрити елемент',
    opensItemPageFromStore: 'Відкриває сторінку елемента з магазину',
    showNewModal: 'Показати нове модальне вікно',
    displayContentInModalWindow: 'Відобразити вміст у модальному вікні',
    showProduct: 'Показати Продукт',
    displayProductInModalWindow: 'Відобразити товар у модальному вікні',
    showBlog: 'Показати блог',
    scrollToBlock: 'Прокрутити до Блоку',
    scrollToBlockText: 'Прокручує до зазначеного блоку сторінки',
    scrollToItem: 'Прокрутити до елемента',
    action: 'Дія',
    showBlock: 'Показати Блок',
    showBlockText: 'Відображає блок у модальному вікні на сторінці',
    showItem: 'Показати Елемент',
    showItemText: 'Відображає блок елемента у модальному вікні на сторінці',
    linksCaption: 'Посилання',
    linksTooltip: 'Виберіть посилання з блоку посилань',
    pagesCaption: 'Сторінки',
    pagesTooltip: 'Виберіть сторінку зі списку',
    productsCaption: 'Продукти',
    productsTooltip: 'Виберіть продукт зі списку',
    blocksCaption: 'Блоки',
    blocksTooltip: 'Виберіть блок зі списку',
    itemsCaption: 'Елементи',
    itemsTooltip: 'Виберіть елемент зі списку',
    showProductText: 'Відображає продукт у модальному вікні на сторінці',
    more: 'Показати більше',
    less: 'Показати менше',
    showNewModalTitle: 'Дані нового модального вікна',
    uploadDocumentTitle: 'Натисніть, щоб завантажити, або перетягніть',
    uploadProgressTitle: 'Завантаження...',
    haveNoModal: 'У вас немає модального вікна',
    haveModal: 'Ви вибрали модальне вікно',
    openNewModalHandler: 'Створити нове модальне вікно',
    linkGroupSubTitle: 'Виберіть блок',
    linkItemSubTitle: 'Виберіть посилання',
    urlItemSubTitle: 'URL вебсайту',
    openInAppItemSubTitle: 'URL застосунку',
    sendEmailItemSubTitle: 'Email-адреса',
    phoneCallItemSubTitle: 'Номер телефону',
    openPageGroupSubTitle: 'Виберіть сторінку',
    openPageItemSubTitle: 'Виберіть сторінку',
    openProductGroupSubTitle: 'Виберіть тип продукту',
    openProductItemSubTitle: 'Виберіть продукт',
    openBlogGroupSubTitle: 'Виберіть канал блогу',
    openBlogItemSubTitle: 'Виберіть статтю блогу',
    openBlockGroupSubTitle: 'Виберіть сторінку',
    openBlockItemSubTitle: 'Виберіть блок',
    openItemGroupSubTitle: 'Виберіть блок',
    openItemItemSubTitle: 'Виберіть елемент',
    showProductGroupSubTitle: 'Виберіть тип продукту',
    showProductItemSubTitle: 'Виберіть продукт',
    showBlogGroupSubTitle: 'Виберіть канал блогу',
    showBlogItemSubTitle: 'Виберіть статтю блогу',
    showBlockGroupSubTitle: 'Виберіть сторінку',
    showBlockItemSubTitle: 'Виберіть блок',
    showItemGroupSubTitle: 'Виберіть блок',
    showItemItemSubTitle: 'Виберіть елемент',
    scrollToBlockGroupSubTitle: 'Виберіть сторінку',
    scrollToBlockItemSubTitle: 'Виберіть блок',
    scrollToItemGroupSubTitle: 'Виберіть блок',
    scrollToItemItemSubTitle: 'Виберіть елемент',
    linkGroupPlaceholder: 'Виберіть блок...',
    linkItemPlaceholder: 'Виберіть посилання...',
    openPageItemPlaceholder: 'Виберіть сторінку...',
    openProductGroupPlaceholder: 'Виберіть тип продукту...',
    openProductItemPlaceholder: 'Виберіть продукт...',
    showProductGroupPlaceholder: 'Виберіть групу продуктів...',
    showProductItemPlaceholder: 'Виберіть продукт...',
    openBlogGroupPlaceholder: 'Виберіть канал блогу...',
    openBlogItemPlaceholder: 'Виберіть статтю блогу...',
    openBlockGroupPlaceholder: 'Виберіть сторінку...',
    openBlockItemPlaceholder: 'Виберіть блок...',
    openItemGroupPlaceholder: 'Виберіть сторінку та блок...',
    openItemItemPlaceholder: 'Виберіть елемент...',
    showBlogGroupPlaceholder: 'Виберіть групу блогу...',
    showBlogItemPlaceholder: 'Виберіть допис блогу...',
    showBlockGroupPlaceholder: 'Виберіть сторінку...',
    showBlockItemPlaceholder: 'Виберіть блок...',
    showItemGroupPlaceholder: 'Виберіть сторінку та блок...',
    showItemItemPlaceholder: 'Виберіть елемент...',
    scrollToBlockGroupPlaceholder: 'Виберіть сторінку...',
    scrollToBlockItemPlaceholder: 'Виберіть блок...',
    scrollToItemGroupPlaceholder: 'Виберіть сторінку та блок...',
    scrollToItemItemPlaceholder: 'Виберіть елемент...',
    linkReadable: 'Посилання',
    urlReadable: 'URL',
    openInAppReadable: 'Відкрити в застосунку',
    downloadDocumentReadable: 'Завантажити документ',
    sendEmailReadable: 'Надіслати email',
    phoneCallReadable: 'Телефонний дзвінок',
    openPageReadable: 'Відкрити сторінку',
    openProductReadable: 'Відкрити продукт',
    showNewModalReadable: 'Показати нове вікно',
    showProductReadable: 'Показати продукт',
    openBlogReadable: 'Відкрити блог',
    openBlockReadable: 'Відкрити блок',
    openItemReadable: 'Відкрити елемент',
    showBlogReadable: 'Показати блог',
    showBlockReadable: 'Показати блок',
    showItemReadable: 'Показати елемент',
    scrollToBlockReadable: 'Прокрутити до блоку',
    scrollToItemReadable: 'Прокрутити до елемента',
  },
  design: {
    tabs: 'Таби',
    imageView: 'Зображення',
    preview: 'Перегляд',
    buttonOpacity: 'Прозорість кнопки',
    buttonBorder: 'Рамка кнопки',
    buttonShadow: 'Тінь кнопки',
    itemView: 'Вид елемента',
    itemViewTooltip: 'Виберіть вид елемента',
    itemLayout: 'Макет елемента',
    itemLayoutTooltip: 'Виберіть макет елемента',
    top: 'Зверху',
    center: 'По центру',
    bottom: 'Знизу',
    bottomLeft: 'Внизу ліворуч',
    bottomHorizontal: 'Горизонтально внизу',
    under: 'Під',
    title: 'Заголовок',
    titleButton: 'Заголовок та кнопка',
    displayOptions: 'Параметри відображення',
    displayOptionsTooltip: 'Виберіть параметри відображення',
    landscape: 'Пейзаж',
    square: 'Квадрат',
    portrait: 'Портрет',
    desktopMode: 'Режим екрану',
    mobile: 'Компактний',
    desktop: 'Широкий',
    responsive: 'Чуйний',
    custom: 'Власний',
    templates: 'Шаблони',
    chooseTemplates: 'Виберіть ваші шаблони',
    viewAll: 'Переглянути все',
    previousTheme: 'Зверніть увагу, що попередня тема буде безповоротно видалена.',
    useThisTemplate: 'Використати цей шаблон',
    notSupportedVideo: 'Ваш браузер не підтримує відеотег.',
    photosBy: 'Фотографії від',
    animationBy: 'Анімація від',
    searchTheSame: 'Шукайте те ж саме знову для інших результатів.',
    addImage: 'Додати зображення',
    addVideo: 'Додати відео',
    orSelectFrom: 'або виберіть з',
    noImagesYet: 'Ще немає зображень',
    noVideosYet: 'Ще немає відео',
    videoBy: 'Відео від',
    hamburgerMenu: 'Меню гамбургера',
    tabsOnTop: 'Вкладки зверху',
    tabsOnBottom: 'Вкладки знизу',
    borderType: 'Тип межі',
    subTitle: 'Виберіть форму, тип межі, тінь тощо.',
    icon: 'Іконка',
    iconTooltip: 'Виберіть правильну іконку для вашої кнопки',
    background: 'Фон',
    color: 'Колір',
    backgroundOpacity: 'Прозорість фону',
    backgroundOpacityTooltip: 'Перетягніть повзунок, щоб встановити прозорість фону',
    gradient: 'Градієнт',
    color1: 'Колір 1',
    color2: 'Колір 2',
    direction: 'Напрямок',
    directionTooltip: 'Перетягніть повзунок, щоб встановити напрямок градієнта',
    offset: 'Зсув',
    offsetTooltip: 'Перетягніть повзунок, щоб встановити зсув градієнта',
    minHeight: 'Мінімальна висота',
    minHeightTooltip: 'Перетягніть повзунок, щоб змінити мінімальну висоту кнопки',
    align: 'Вирівнювання',
    alignTooltip: 'Змініть позицію кнопки',
    insert: 'Вставити URL',
    upload: 'Завантажити відео',
    search: 'Пошук відео',
    layout: 'Макет',
    layoutTooltip: 'Виберіть потрібний макет',
    view: 'Перегляд',
    viewTooltip: 'Виберіть бажаний вигляд',
    media: 'Медіа',
    mediaTooltip: 'Виберіть потрібне медіа',
    none: 'Немає',
    small: 'Малий',
    medium: 'Середній',
    large: 'Великий',
    round: 'Круглий',
    feed: 'Стрічка',
    slider: 'Слайдер',
    text: 'Текст',
    colorTooltip: 'Виберіть кольори',
    button: 'Кнопка',
    buttonTooltip: 'Виберіть кольори кнопки',
    chooseEmoji: 'Виберіть емодзі',
    changeEmoji: 'Змініть ваш емодзі',
    quantum: 'Квант',
    emoji: 'Емодзі',
    warp: 'Варп',
  },
  components: {
    quickAdd: {
      addLink: 'Додати посилання',
      addVideo: 'Додати відео',
      addProduct: 'Додати продукт',
      addPost: 'Додати допис',
      addArticle: 'Додати статтю',
      addPhoto: 'Додати фото',
      addMusic: 'Додати музику',
      addFiles: 'Додати файли',
      addStory: 'Додати історію',
    },
    emoji: {
      search: 'Пошук',
      clear: 'Очистити',
      notfound: 'Нічого не знайдено',
      skintext: 'Виберіть стандартный колір шкіри',
      categories: {
        search: 'Результати пошуку',
        recent: 'Часто використовувані',
        smileys: 'Смайли та емоції',
        people: 'Люди та тіло',
        nature: 'Тварини та природа',
        foods: 'Їжа та напої',
        activity: 'Активність',
        places: 'Подорожі та місця',
        objects: 'Предмети',
        symbols: 'Символи',
        flags: 'Прапори',
        custom: 'Свій',
      },
      categorieslabel: 'Категорії емодзі',
      skintones: {
        1: 'За замовчуванням',
        2: 'Світлий',
        3: 'Середньо-світлий',
        4: 'Середній',
        5: 'Середньо-темний',
        6: 'Темний',
      },
    },
    blogPreviewModal: {
      title: 'Попередній перегляд блогу',
      notify: 'Сповістити підписників',
    },
    standAloneModal: {
      title: 'Попередній перегляд посилання',
      save: 'Зберегти',
      chooseLayout: 'Виберіть макет для вашого посилання',
      linkSettings: 'Налаштування посилання',
      linkSettingsSubtitle: 'Перенаправлення, вигляд',
      whenVisitorsClicks: 'Коли відвідувач натискає це посилання:',
      redirect: 'Перенаправлення',
      redirectText: 'Перенаправити відвідувачів на вашу сторінку',
      highlight: 'Виділити',
      highlightText: 'Надіслати відвідувачів на ваш UniLink і виділити',
      standalone: 'Окремий',
      standaloneText: 'Зробіть ваше посилання на YouTube помітним та відтворюйте контент безпосередньо на вашому',
      cover: 'Обкладинка',
      imageTab: 'Зображення',
      videoTab: 'Відео',
      uploadImage: 'Завантажити зображення',
      whenVisitors: 'Коли відвідувач обирає спільне посилання:',
      compact: 'Компактний вигляд',
      fullView: 'Повний вигляд',
      videoSound: 'Відтворювати відео зі звуком',
    },
    instagramModal: {
      title: 'Надсилайте автоматичні повідомлення в Instagram',
      subtitle: 'Надішліть це посилання через приватне повідомлення, коли хтось коментує ваш допис або Reel в Instagram',
      promo: 'Виберіть, з якого Instagram акаунта ви хочете відправляти',
      connect: 'Підключити акаунт Instagram',
      added: 'Акаунт Instagram додано',
      addNew: 'Додати нову автоматизацію',
      igContent: 'Контент IG',
      trigger: 'Тригер',
      dmContent: 'Приватне повідомлення',
      linkDestination: 'Посилання',
      buttonTitle: 'Назва кнопки',
      buttonTitleTooltip: 'Введіть назву кнопки',
      directMessage: 'Приватне повідомлення',
      directMessageTooltip: 'Введіть приватне повідомлення',
      selectPosts: 'Виберіть допис або Reel, який запустить автоматичне повідомлення.',
      onePost: 'Один конкретний допис або Reel',
      allPosts: 'Усі дописи або Reels',
      triggerText: 'Коли коментарі містять це, ваше приватне повідомлення буде надіслано.',
      addMessage: 'Додайте повідомлення, яке буде автоматично надіслане з вашим посиланням.',
      clickLink: 'Коли хтось натисне на посилання в вашому приватному повідомленні:',
      anyComment: 'Будь-який коментар',
      specificKeywords: 'Коментарі з певними ключовими словами',
      sendLink: 'Надішліть їх на ваш UniLink і виділіть ',
      skipLink: 'Пропустити UniLink і відправити їх напряму',
      keywordsTitle: 'Коментарі з певними ключовими словами',
      keywordsText: 'Ваші приватні повідомлення будуть відправлені, коли коментарі включають або виключають\nпевні ключові слова (без урахування регістру):',
      keywordsPlaceholder: 'Введіть ключове слово',
      keywordsExclude: 'Виключити ключові слова',
      keywordsExcludeText: 'Має виключати будь-яке з цих ключових слів',
      replyComment: 'Відповісти на коментар',
      replyCommentTooltip: 'Введіть відповідь на коментар',
    },
    blockEditProduct: {
      productPreview: 'Мініатюра',
      productDetails: 'Деталі',
      settings: 'Налаштування',
      design: 'Дизайн',
    },
    editMenuItems: {
      overview: 'Огляд',
      analytics: 'Аналітика',
    },
    botToken: {
      bot: 'Бот',
      botTooltip: 'Введіть токен вашого бота',
      connect: 'Підключити',
      token: 'Токен',
    },
    rewards: {
      title: 'Заголовок',
      titleTooltip: 'Введіть заголовок для нагороди',
      text: 'Текст',
      textTooltip: 'Введіть текст для нагороди',
      link: 'Посилання',
      linkTooltip: 'Введіть посилання для нагороди',
      code: 'Код',
      codeTooltip: 'Введіть код для нагороди',
      files: 'Файли',
      filesTooltip: 'Введіть файли для нагороди',
      removeReward: 'Are you sure you want to remove this reward?',
    },
    addRewardModal: {
      addReward: 'Додати нагороду',
      textTitle: 'Текст',
      textText: 'Надайте доступ до інструкції або будь-якого тексту за допомогою редактора Rich Editor',
      fileTitle: 'Файли',
      fileText: 'Надайте доступ до файлів та збирайте контактні дані',
      linkTitle: 'Посилання',
      linkText: 'Надайте доступ до ексклюзивного контенту та збирайте контактні дані',
      codeTitle: 'Код',
      codeText: 'Надайте доступ до ексклюзивних промоцій та збирайте контактні дані',
    },
    blockEmpty: {
      isNotAdded: 'не додано',
      itSeems: 'Схоже, що ваші',
      itemsNot: 'елементи ще не додані. Додайте свої відео зараз',
      add: 'Додати',
    },
    blockList: {
      add: 'Додати',
      item: 'елемент',
    },
    submitAction: {
      action: 'Дія (після відправки)',
      actionTooltip: 'Виберіть дію після відправки',
      upload: 'Завантажити вкладення',
      none: 'Немає',
      page: 'Показати сторінку підтвердження',
      email: 'Надіслати підтвердження електронною поштою',
      redirect: 'Перенаправити на URL',
    },
    blockEditItem: {
      content: 'Вміст',
      preview: 'Попередній перегляд',
      settings: 'Налаштування',
    },
    domainButton: {
      customizeDomain: 'Налаштуйте ваш домен.',
      upgradeToLink: 'Оновіть до Link in Bio Pro і використовуйте власний домен.',
    },
    coverText: {
      text: 'Текст',
      textTooltip: 'Введіть текст для вашої обкладинки',
      description: 'Опис',
      descriptionTooltip: 'Введіть опис для вашої обкладинки',
      textColor: 'Колір тексту',
    },
    itemModal: {
      edit: 'Редагувати',
      addNew: 'Додати новий',
      item: 'елемент',
      update: 'Оновити',
      add: 'Додати',
    },
    viewDesign: {
      compact: 'Компактний',
      card: 'Картка',
      button: 'Кнопка',
      list: 'Список',
      hero: 'Герой',
      featured: 'Рекомендоване',
    },
    moveItemModal: {
      title: 'Перемістити елемент на іншу сторінку',
      cancel: 'Скасувати',
      move: 'Перемістити',
      page: 'Сторінка',
      pageTooltip: 'Виберіть сторінку для переміщення елемента',
      blocks: 'Блоки',
      blocksTooltip: 'Виберіть блок для переміщення елемента',
      emptyBlocks: 'На цій сторінці немає необхідних блоків.',
    },
    limitModal: {
      title: 'Досягнуто ліміту',
      text1: 'Ви досягли ліміту вашого сайту.',
      text2: "Будь ласка, зв'яжіться з нами для оновлення вашого плану.",
      close: 'Закрити',
    },
    cropPicture: {
      title: 'Обрізати зображення',
      cancel: 'Скасувати',
      save: 'Зберегти',
    },
    uploadFile: {
      uploadProductImage: 'Завантажити зображення продукту',
      coverImage: 'Обкладинка',
      uploadImages: 'Ви можете завантажувати тут тільки зображення',
    },
    userMediaLibrary: {
      addImage: 'Додати зображення',
      uploadImage: 'Завантажити зображення',
      orSelectFrom: 'або завантажити',
      orSelectLink: 'або вставити посилання',
      myMedia: 'Моя медіатека',
      stockImages: 'Стокові зображення',
      gifs: 'GIF',
      icons: 'Іконки',
      noImagesYet: 'Ще немає зображень',
      loadMore: 'Завантажити більше',
    },
    itemMenu: {
      active: 'Активний',
      willBeAvailable: 'Елемент буде доступний по:',
      save: 'Зберегти',
      copied: 'Скопійовано',
      copyLink: 'Скопіювати посилання',
      delete: 'Видалити',
    },
    itemDesign: {
      linkColor: 'Колір посилання',
      gradient: 'Градієнт',
      background: 'Фон',
      backgroundOpacity: 'Прозорість фону',
      backgroundOpacityTooltip: 'Перетягніть повзунок для встановлення прозорості фону',
      backgroundDarkness: 'Затемнення фону',
      backgroundDarknessTooltip: 'Перетягніть повзунок, щоб встановити затемнення фону',
      text: 'Текст',
      color1: 'Колір 1',
      color2: 'Колір 2',
      direction: 'Напрямок',
      directionTooltip: 'Перетягніть повзунок для встановлення напряму градієнта',
      offset: 'Зсув',
      offsetTooltip: 'Перетягніть повзунок для встановлення зсуву градієнта',
      linkHeight: 'Висота посилання',
      linkHeightTooltip: 'Перетягніть повзунок для зміни висоти кнопки',
      icon: 'Іконка',
      iconTooltip: 'Виберіть іконку для вашої кнопки',
      imageShape: 'Форма зображення',
      imageShapeTooltip: 'Виберіть форму зображення для вашого посилання',
    },
    menu: {
      linkInBio: 'Link in Bio',
      linkInBioApps: 'Link in Bio',
      posts: 'Пости',
      audience: 'Аудиторія',
      orders: 'Магазин',
      marketing: 'Маркетинг',
      emailMarketing: 'Email-маркетинг',
      socialPlanner: 'Контент-планер',
      shortLinks: 'Короткі посилання',
      recentProfiles: 'Останні профілі',
      standalonePage: 'Окрема сторінка',
      soloApps: 'Соло-додатки',
      bots: 'Боти',
      smartReply: 'Розумна відповідь',
      analytics: 'Аналітика',
      settings: 'Налаштування',
      shop: 'Магазин',
      publish: 'Опублікувати',
      studio: 'Студія',
      blog: 'Блог',
      qrCodes: 'QR-коди',
      singlePages: 'Додатки',
      forms: 'Форми',
      form: 'Форми',
      automations: 'Автоматизації',
      community: 'Спільнота',
      messages: 'Повідомлення',
      agents: 'Агенти',
      apps: 'Програми',
    },
    notificationsBlockSetting: {
      title: 'Сповіщення',
      setUp: 'Налаштувати',
      notifications: 'сповіщення',
      connect: 'Підключити',
      telegramText: 'Отримуйте сповіщення в Telegram, коли хтось зробить',
      change: 'змінити',
      email: 'Email',
      emailText: 'Отримуйте електронний лист, коли хтось зробить',
      webhook: 'Webhook',
      webhookTooltip: 'Додати webhook',
      activate: 'Активувати',
      webhookText: 'Надішліть подію на сторонній вебсайт, коли хтось зробить',
      webhookURL: 'URL вебхука (POST-запит)',
      error: 'Введіть правильне посилання',
      save: 'Зберегти',
    },
    navigation: {
      content: 'Вміст',
      pages: 'Сторінки',
      posts: 'Пости',
      shop: 'Магазин',
      blog: 'Блог',
      design: 'Дизайн',
      analytics: 'Аналітика',
      settings: 'Налаштування',
      apps: 'Програми',
      store: 'Магазин',
    },
    headerSettings: {
      design: 'Дизайн',
      analytics: 'Аналітика',
      settings: 'Налаштування',
      editTabs: 'Редагувати',
    },
    unlockModal: {
      title: 'Розблокуйте Pro',
      text: 'Отримайте більше від свого посилання в біо. Лише $5/місяць — відкрийте всі можливості Pro:',
      checkBoxTitle1: 'Більше блоків:',
      checkBoxText1: 'Форми, магазини, таймери та медіаплеєри',
      checkBoxTitle2: 'Розширена аналітика:',
      checkBoxText2: 'Переходи, перегляди та аналіз аудиторії',
      checkBoxTitle3: 'Власний домен:',
      checkBoxText3: 'Підключіть свій домен для профі-вигляду',
      checkBoxTitle4: 'Вбудований магазин:',
      checkBoxText4: 'Продавайте товари та керуйте замовленнями',
      checkBoxTitle5: 'SEO-інструменти:',
      checkBoxText5: 'Мета-теги, UTM та кастомні посилання',
      checkBoxTitle6: 'Інтеграції:',
      checkBoxText6: 'Mailchimp, Zapier та інші популярні сервіси',
      checkBoxTitle7: 'Email-маркетинг:',
      checkBoxText7: 'Збирайте ліди та відправляйте автокампанії',
      checkBoxTitle8: 'Пріоритетна підтримка:',
      checkBoxText8: 'Швидша допомога коли вона потрібна',
      upgradeToPro: 'Перейти на Pro',
      viewAllPlans: 'Переглянути всі плани',
    },
    profileSwitcher: {
      title: 'Усі профілі',
      button: 'Додати новий профіль',
    },
    account: {
      signOut: 'Вийти',
      createNew: 'Створити новий Link in Bio',
      tryPro: 'Спробуйте Pro зараз!',
      tryProText: 'Отримайте розширену кастомізацію та глибше розуміння аудиторії, щоб залучити більше відвідувачів!',
    },
    accountSettings: {
      title: 'Налаштування облікового запису',
    },
    billingHistory: {
      title: 'Історія оплат',
    },
    pages: {
      home: 'Головна',
      newPage: 'Нова сторінка',
      managePages: 'Керувати сторінками',
    },
    blockItem: {
      actionRequired: 'потрібна дія',
    },
    blockContent: {
      untitled: 'Без назви',
      clickToRename: 'Клацніть, щоб перейменувати підзаголовок',
      saving: 'збереження',
      saved: 'збережено',
      deleteTitle: 'Ви впевнені, що хочете видалити цей блок?',
      cancel: 'Скасувати',
      yes: 'Так',
    },
    addButtonModal: {
      title: 'Додати діючу кнопку',
      close: 'Закрити',
      added: 'Додано',
      add: 'Додати',
      messageTitle: 'Повідомлення',
      messageText: "Кнопка повідомлення дозволяє відвідувачам зв'язатися з вами через месенджери",
      subscribeTitle: 'Підписатися',
      subscribeText: 'Кнопка підписки дозволяє користувачам підписатися на вашу електронну пошту або список месенджерів',
      ctaTitle: 'Кнопка CTA',
      ctaText: 'CTA - це заклик до дії на вебсайті, який закликає користувача здійснити певну дію',
      cartTitle: 'Кошик',
      cartText: 'Показує значок кошика покупок, що вказує на можливість здійснювати покупки на вашому вебсайті',
      contactTitle: 'Контакт',
      contactText: 'Дозволяє відвідувачам швидко отримати доступ до вашої контактної інформації',
      qrcodeTitle: 'QR Code',
      qrcodeText: 'Показує QR код, щоб відвідувачі могли швидко відсканувати та поділитися вашою сторінкою',
      languageTitle: 'Мова',
      languageText: 'Дозволяє відвідувачам перемикати мову вашої сторінки',
    },
    inputMask: {
      copyLink: 'Копіювати посилання',
    },
    videoLibrary: {
      addVideo: 'Додати відео',
      myVideos: 'Мої відео',
      stockVideos: 'Стокові відео',
      pasteUrl: 'Вставити URL',
      uploadVideo: 'Завантажити відео',
    },
    createBlockModal: {
      searchTitle: 'Оберіть блок для своєї сторінки',
      title: 'Додати до UniLink',
      contentTitle: 'Контент',
      contentText: 'Створюйте та керуйте своєю сторінкою',
      growTitle: 'Ліди',
      growText: 'Збирайте ліди та підвищуйте залученість',
      monetizeTitle: 'Монетизація',
      monetizeText: 'Продавайте товари, контент та послуги',
      monetizationTitle: 'Заробляйте та отримуйте кошти',
      monetizationText: 'Продавайте товари, послуги та приймайте донати',
      socialTitle: 'Контент соцмереж',
      socialText: 'Діліться контентом соцмереж на своєму UniLink',
      toolsTitle: 'Інструменти Зростання',
      toolsText: 'Зростайте, керуйте та спілкуйтеся з аудиторією',
      search: 'Пошук',
      all: 'Усе',
      allCategories: 'Усі категорії',
      content: 'Контент',
      monetization: 'Монетизація',
      social: 'Соцмережі',
      tools: 'Інструменти',
      header: 'Заголовок',
      headerText: 'Додати фото профілю та біографію',
      link: 'Посилання',
      linkText: 'Виберіть макет посилання',
      text: 'Текст',
      textText: 'Виберіть макет тексту',
      videos: 'Відео',
      videosText: 'Виберіть тип відео',
      image: 'Зображення',
      imageText: 'Додайте блоки зображень',
      music: 'Музика',
      musicText: 'Виберіть тип музики',
      socialFeeds: 'Соціальні стрічки',
      socialFeedsText: 'Виберіть тип соціальної стрічки',
      moreContent: 'Більше контенту',
      moreContentText: 'Додайте блоки з додатковим контентом',
      dataCollect: 'Збір даних',
      dataCollectText: 'Виберіть тип збору даних',
      form: 'Форма',
      formText: 'Виберіть тип форми',
      conversionTools: 'Інструменти залучення',
      conversionToolsText: 'Додайте блоки конверсії',
      products: 'Продукти',
      productsText: 'Додайте блоки продуктів',
      donation: 'Тіпси та Донати',
      tipsAndDonations: 'Тіпси та Донати',
      tipsDonationsText: 'Блоки тіпсів та донатів',
      event: 'Подія',
      eventText: 'Виберіть тип події',
      quickAdd: 'Всі блоки',
      quickAddText: 'Додайте блок',
    },
    addBlockModal: {
      title: 'Додати до UniLink',
      dragToAdd: 'Перетягніть щоб додати',
      contentTitle: 'Поділитися основним контентом',
      contentText: 'Діліться контентом безпосередньо на вашому UniLink',
      monetizationTitle: 'Заробляйте та збирайте гроші',
      monetizationText: 'Продавайте товари, послуги та отримуйте чайові',
      socialTitle: 'Контент з соціальних мереж',
      socialText: 'Діліться контентом соціальних мереж на вашому UniLink',
      toolsTitle: 'Інструменти для зростання',
      toolsText: 'Ростіть, керуйте та комунікуйте зі своєю аудиторією',
      search: 'Пошук',
      searchPlaceholder: 'Пошук блоку...',
      all: 'Усі',
      allCategories: 'Усі категорії',
      content: 'Контент',
      monetization: 'Монетизація',
      social: 'Соціальні',
      tools: 'Інструменти',
    },
    tabNavigation: {
      tabView: 'Перегляд вкладок',
      tabViewTooltip: 'Виберіть перегляд вкладок для навігації',
      colors: 'Кольори',
      colorsTooltip: 'Виберіть кольори постів і кнопок',
      tabs: 'Вкладки',
      tabsTooltip: 'Виберіть вкладки, які відображаються в навігації сайту',
      content: 'Контент',
      posts: 'Пости',
      store: 'Магазин',
      shop: 'Магазин',
      tabsSettings: 'Налаштування навігації по вкладках',
    },
    hideLogo: {
      text: 'Показувати логотип UniLink у футері вашої сторінки.',
      text2: 'Показувати логотип UniLink у футері вашої сторінки.',
    },
    palettePreview: {
      custom: 'Власний колір фону',
      hexColor: 'Hex колір',
      hexColorTooltip: 'Введіть hex колір для вашого попереднього перегляду',
    },
    backgroundVideo: {
      insert: 'Вставити URL',
      upload: 'Завантажити відео',
      search: 'Пошук відео',
    },
    periodDropdown: {
      today: 'Сьогодні',
      yesterday: 'Вчора',
      last7days: 'Останні 7 днів',
      last30days: 'Останні 30 днів',
      allTime: 'За весь час',
      custom: 'Користувацькі',
    },
    subsections: {
      content: 'Контент',
      design: 'Дизайн',
      settings: 'Налаштування',
    },
    wrapperSettings: {
      lock: 'Оновіть до PRO плану',
    },
    shareModal: {
      addSocials: 'Додати до соцмереж',
      shareTo: 'Поділитися у',
      qrCode: 'QR-код',
      customizeUrl: 'Налаштувати URL',
      goToMy: 'Перейти до мого',
      print: 'Ви можете надрукувати свій унікальний QR-код на',
      cards: 'візитних картках і флаєрах',
      download: 'Завантажити',
      copy: 'Копіювати',
      previewMobile: 'Переглянути на мобільному',
      scanMobilePreview: 'Сканувати QR-код на вашому мобільному пристрої',
      types: {
        socials: 'соцмережі',
        shareTo: 'поділитися',
        qrCode: 'QR-код',
        title: 'Поділіться вашим UniLink',
        titleSocials: 'Додайте UniLink до ваших соцмереж',
        titleShareTo: 'Поділитися у...',
        titleQRCode: 'QR-код',
        titlePreviewMobile: 'Вигляд на телефоні',
      },
      socialList: {
        instagramText: 'Додайте ваш UniLink до профілю Instagram. Просто скопіюйте URL вашого UniLink, перейдіть до "Редагування профілю" і вставте його в поле Вебсайт.',
        facebookText:
          'Додайте ваш UniLink до профілю Facebook. Просто скопіюйте URL вашого UniLink, перейдіть на сторінку "Про вас" у вашому профілі, натисніть на Контактна інформація та основні відомості, потім натисніть + Додати вебсайт, вставте URL вашого UniLink у поле Вебсайт, і натисніть Зберегти.',
        tikTokText:
          'Додайте ваш UniLink до профілю TikTok. Просто скопіюйте URL вашого UniLink, перейдіть до вашого профілю TikTok, натисніть на "Редагування профілю", і вставте URL вашого UniLink в поле Вебсайт.',
        twitchText:
          'Додайте ваш UniLink до вашого каналу Twitch. Просто скопіюйте URL вашого UniLink, перейдіть до вашого каналу Twitch, натисніть "Про канал", потім натисніть "Редагувати налаштування про канал" і "посилання", прокрутіть вниз до "Соціальних посилань", додайте UniLink в перше текстове поле, і вставте URL вашого UniLink у друге текстове поле, потім натисніть Додати.',
        youTubeText:
          'Додайте ваш UniLink до вашого каналу YouTube. Просто скопіюйте URL вашого UniLink, перейдіть до вашого каналу YouTube, натисніть Налаштувати канал, потім натисніть Основна інформація, і під "Посилання" додайте назву посилання і вставте URL вашого UniLink в поле URL, потім натисніть Опублікувати.',
        linkedInText:
          'Додайте ваш UniLink до вашого профілю LinkedIn. Просто скопіюйте URL вашого UniLink, перейдіть до вашого профілю LinkedIn, натисніть на значок олівця, прокрутіть вниз до "Контактна інформація", вставте URL вашого UniLink у поле Вебсайт, потім натисніть Застосувати.',
        pinterestText:
          'Додайте ваш UniLink до вашого профілю Pinterest. Просто скопіюйте URL вашого UniLink, перейдіть до налаштувань Pinterest, вставте URL вашого UniLink у поле Вебсайт, потім натисніть Зберегти.',
        twitterText:
          'Додайте ваш UniLink до вашого профілю Twitter. Просто скопіюйте URL вашого UniLink, перейдіть до вашого профілю, натисніть на "Редагування профілю", і вставте URL вашого UniLink в поле Вебсайт.',
      },
      share: {
        shareFacebook: 'Поділитися у Facebook',
        shareLinkedIn: 'Поділитися у LinkedIn',
        shareTwitter: 'Поділитися у Twitter',
        shareWhatsApp: 'Поділитися через WhatsApp',
        shareMessenger: 'Поділитися через Messenger',
        shareEmail: 'Поділитися через Email',
      },
    },
  },
  popupMenu: {
    edit: 'Редагувати',
    openInNewTab: 'Відкрити у новій вкладці',
    copyLink: 'Скопіювати URL',
    delete: 'Видалити',
    showThumbnail: 'Показувати мініатюри сторінок на панелі керування',
    manageTabs: 'Керувати вкладками',
  },
  tabsDashboard: {
    labelAddNewTab: 'Нова вкладка',
  },
  blocks: {
    header: {
      blockTitle: 'Хедер',
      blockText: 'Налаштуйте зображення профілю, додайте коротке біо та соціальні іконки',
      blockShortText: 'Налаштуйте свій профіль',
      layout: 'Макет',
      layoutTooltip: 'Створіть бажаний макет заголовка',
      layoutAlign: 'Вирівнювання макета',
      layoutAlignTooltip: 'Вирівняйте текст',
      profilePicture: 'Фото профілю',
      profilePictureTooltip: 'Змініть фото профілю',
      pictureSize: 'Розмір зображення',
      pictureSizeTooltip: 'Ви можете змінити розмір зображення',
      pictureHeight: 'Висота зображення',
      pictureHeightCaption: 'Ви можете змінити висоту зображення',
      preview: 'Попередній перегляд',
      badge: 'Галочка',
      badgeTooltip: 'Додайте верифікаційну галочку до хедеру',
      tags: 'Теги',
      tagsTooltip: 'Показати теги категорій під іменем (до 5)',
      tagsAdd: 'Додати теги',
      addTags: '+ Додати теги',
      tagsEdit: 'Редагувати теги',
      tagsCustomPlaceholder: 'Додати свій тег',
      tagsCustomAdd: 'Додати',
      tagsSuggested: 'Запропоновані категорії',
      tagsSelected: 'Обрано',
      tagsEmpty: 'Тегів ще немає — оберіть зі списку або додайте свій',
      tagsLimit: 'Максимум 5 тегів',
      visibility: 'Видимість',
      visibilityTooltip: 'Показати або сховати фото профілю',
      cover: 'Обкладинка',
      coverTooltip: 'Додати медіа до обкладинки хедеру',
      addCover: 'Додати обкладинку',
      image: 'Картинка',
      video: 'Відео',
      positionCover: 'Позиція обкладинки тексту та кнопки',
      positionCoverTooltip: 'Перетягніть повзунок для зміни позиції',
      buttons: 'Кнопки',
      block: 'Блок',
      videoProcessing: 'Обробка відео',
      vibe: 'Настрій',
      vibeTooltip: 'Додайте свій настрій',
      stories: 'Історії',
      storiesTooltip: 'Додайте свої історії',
      addStory: 'Додати історію',
      storiesSubtitle: 'Додайте зображення або відео до своїх історій',
      subscribeMethod: 'Метод підписки',
      subscribeMethodTooltip: 'Виберіть метод підписки',
      subscribeLink: 'Посилання на підписку',
      subscribeLinkTooltip: 'Копіювати посилання',
      minWidth: 'Мінімальна ширина',
      addVCard: 'Додати VCard',
      vCard: 'VCard',
      vCardTooltip: 'Ви можете додати інформацію про себе',
      buttonInline: 'Кнопка всередині заголовка',
      buttonInsideContact: 'Кнопка всередині кнопки "Контакти"',
      showSaveContact: 'Показати збереження контакту',
      needAddContact: 'Вам потрібно додати кнопку "Контакти"',
      socialGap: 'Відступ',
      socialGapCaption: 'Ви можете змінити відступ',
      socialSize: 'Розмір',
      socialSizeCaption: 'Ви можете змінити розмір',
      icons: 'Іконки',
      iconsTooltip: 'Додати іконку до кнопки',
    },
    text: {
      blockTitle: 'Текст',
      blockText: 'Загальний текстовий блок для написання всього, що ви хочете. Ви можете форматувати свій текст за допомогою редактора WYSIWYG',
      blockShortText: 'Загальний текстовий блок',
      title: 'Заголовок',
      titleText: 'Налаштуйте розмір вашого заголовка',
      orderOfElements: 'Порядок елементів',
      orderOfElementsTooltip: 'Перетягніть повзунок для зміни порядку елементів',
      changeOrder: 'Змінити порядок',
      text: 'Текст',
      content: 'Зміст',
      image: 'Картинка',
      button: 'Кнопка',
      addButtons: 'Додати більше кнопок',
      displayedContent: 'Показаний зміст',
      displayedContentTooltip: 'Показати або приховати зміст',
      buttonLayout: 'Розташування кнопок',
      buttonLayoutTooltip: 'Оберіть вертикальне або горизонтальне розташування кнопок',
    },
    timeline: {
      blockTitle: 'Таймлайн',
      blockText: 'Вертикальна шкала часу з подіями. Кожна подія може мати дату/час, заголовок, опис та (опційно) зображення',
      blockShortText: 'Шкала часу з подіями',
      editItem: 'Редагувати подію',
      title: 'Заголовок',
      titlePlaceholder: 'Назва події',
      subtitle: 'Підзаголовок',
      subtitlePlaceholder: 'Роль або афіліація (опційно)',
      description: 'Опис',
      descriptionPlaceholder: 'Опис події (опційно)',
      startTime: 'Час початку',
      endTime: 'Час закінчення',
      startDate: 'Дата початку',
      endDate: 'Дата закінчення',
      showEndDate: 'Показувати дату закінчення',
      showEndDateTooltip: 'Вимкніть для подій без кінця (наприклад, «працюю тут з 2023»)',
      includeTime: 'Вказати час',
      includeTimeTooltip: 'Якщо вимкнено, буде показано лише дату без часу',
      image: 'Зображення',
      imagePlaceholder: 'Завантажити аватар або іконку',
      imageUploadFailed: 'Не вдалося завантажити зображення. Використовуйте Мої медіа або вставте посилання.',
      untitled: 'Без назви',
      listLayout: 'Розклад списку',
      lineColor: 'Колір лінії',
    },
    trust: {
      blockTitle: 'Довіра',
      blockShortText: 'Поділіться своїми партнерствами',
      blockText: "Розмістіть усі ваші зв'язки в одному місці.",
      titleText: 'Налаштуйте розмір заголовка',
      orderOfElements: 'Порядок елементів',
      orderOfElementsTooltip: 'Перетягніть повзунок, щоб змінити порядок елементів',
      changeOrder: 'Змінити порядок',
      text: 'Текст',
      content: 'Вміст',
      image: 'Зображення',
      button: 'Кнопка',
      displayedContent: 'Відображуваний вміст',
      displayedContentTooltip: 'Показати або приховати вміст',
      enterTrustLink: 'Введіть URL партнера',
      enterTrustLinkTooltip: 'Вставте URL партнера',
      enterPartnerName: "Введіть ім'я партнера",
      enterPartnerUrl: 'https://www.yourPartner.com/',
      enterDescription: "Введіть опис (необов'язково)",
      partnerLogo: 'Логотип партнера',
      uploadPartnerLogo: 'Завантажте логотип вашого партнера',
    },
    link: {
      blockTitle: 'Посилання',
      blockText: 'Спрямовуйте трафік на ваш вебсайт, блог, інтернет-магазин або будь-які інші вебсторінки. Усі посилання налаштовуються',
      blockShortText: 'Спрямовуйте трафік на вебсайт',
      addLink: 'Додати посилання',
      addNewLink: 'Додати нове посилання',
      viewArchive: 'Переглянути архів',
      archivedLinks: 'Заархівовані посилання',
      noArchivedLinks: 'Тримайте адмін-панель чистою та зручною, архівуючи посилання, які зараз не використовуєте.',
      archiveAllUnpublished: 'Архівувати всі неопубліковані посилання',
      addFormExisting: 'Додати існуючу лінку',
      addYourLink: 'Додайте ваше посилання до групи',
      add: 'Додати',
      otherTypes: 'Тип дії',
      link: 'Посилання',
      navigate: 'Навігація',
      navigateTo: 'Перейти до',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Сторінка',
      navigateProduct: 'Продукт',
      navigateBlock: 'Блок',
      modal: 'Модальне вікно',
      showModal: 'Показати модальне вікно',
      modalBlock: 'Показати блок',
      modalItem: 'Показати елемент',
      modalCustom: 'Власний',
      document: 'Документ',
      privat24: 'Приват24',
      phone: 'Телефонний дзвінок',
      viber: 'Відкрити Viber',
      skype: 'Відкрити Skype',
      email: 'Надіслати електронний лист',
      discount: 'Знижка',
      smartLink: 'Смарт-посилання',
      mobileApp: 'Deep Link',
      enterURL: 'Введіть URL',
      enterPrivat: 'Введіть вашу карту ПриватБанку',
      enterPhone: 'Введіть номер телефону',
      enterViber: 'Введіть номер Viber',
      enterSkype: 'Введіть Skype',
      enterEmail: 'Введіть електронну пошту',
      enterTitle: 'Введіть назву',
      enterCopyText: 'Введіть текст для копіювання',
      enterPromoCode: 'Введіть промокод',
      group: 'Створити групу',
      content: 'Вміст',
      links: 'Посилання',
      heading: 'Заголовок',
      settings: 'Налаштування',
      thumbnail: 'Мініатюра',
      typeTooltip: 'Клік відкриє це посилання',
      title: 'Назва',
      titleTooltip: 'Назва вашого посилання',
      description: 'Опис',
      descriptionTooltip: "Необов'язковий опис характеристик посилання, типів, кольорів, розмірів тощо.",
      label: 'Мітка',
      labelTooltip: 'Додати назву мітки',
      button: 'Кнопка',
      buttonTooltip: 'Додати назву кнопки',
      buttonText: 'Текст кнопки',
      buttonTextTooltip: 'Назва вашої кнопки',
      buttonUrl: 'URL кнопки',
      buttonUrlTooltip: 'Введіть URL кнопки',
      addLinkToGroup: 'Додати посилання до групи',
      removeFromGroup: 'Видалити з групи',
      deletePermanently: 'Видалити назавжди',
      image: 'Зображення',
      buttonBg: 'Фон кнопки',
      postPreview: 'Попередній перегляд посту',
      separatorType: 'Тип роздільника',
      separatorTypeTooltip: 'Додати тип роздільника до вашої кнопки',
      section: 'Розділ',
      sectionTooltip: 'Розділ посилання',
      descriptionSeparator: 'Опис',
      descriptionSeparatorTooltip: "Необов'язковий опис розділу",
      sectionText: 'Текст розділу',
      linkInstant: 'Миттєве перенаправлення посилання',
      spotlight: 'Виділити посилання',
      addEffect: 'Додати спеціальний ефект',
      countdown: 'Зворотний відлік',
      countdownTimer: 'Таймер зворотного відліку',
      countdownText: 'Додати живий зворотний відлік до того, коли ваше посилання стане клікабельним',
      chooseDate: 'Виберіть дату',
      chooseDateTooltip: 'Виберіть дату для вашого посилання',
      chooseAction: 'Виберіть дію',
      chooseActionTooltip: 'Виберіть дію для вашого посилання',
      addCountdown: 'Додати зворотний відлік для посилання',
      scheduler: 'Планувальник',
      schedule: 'Розклад',
      scheduleText: 'Виберіть дату і час у майбутньому, коли ваше посилання стане активним',
      activateOn: 'Активувати о',
      activateOnTooltip: 'Виберіть дату',
      deactivateOn: 'Деактивувати о',
      deactivateOnTooltip: 'Виберіть дату',
      addSchedule: 'Додати розклад для посилання',
      scheduleError: 'Дата завершення не може бути раніше дати початку, а дата початку не може бути в минулому.',
      scheduleErrorPast: 'Дата активації не може бути в минулому.',
      scheduleErrorPastDeactivate: 'Дата деактивації не може бути в минулому.',
      scheduleErrorOrder: 'Дата деактивації має бути після дати активації.',
      activatesIn: 'Активується через',
      deactivatesIn: 'Деактивується через',
      lock: 'Блокування',
      lockText: 'Відвідувачі можуть отримати доступ до цього посилання, виконавши одну з умов.',
      lockCode: 'Код',
      lockCodeTitle: 'Код для розблокування цього посилання',
      lockCodeText: 'Відвідувачі повинні ввести 4-значний код, щоб розблокувати це посилання',
      lockSubscribe: 'Підписка',
      lockSubscribeTitle: 'Відвідувачі повинні підписатися на ваш UniLink, щоб розблокувати посилання.',
      lockSubscribeText: 'Блокування було успішно налаштоване.',
      lockPayment: 'Платіж',
      lockPaymentText: 'Блокування було успішно налаштоване.',
      price: 'Ціна',
      priceTooltip: 'Додати ціну вашого продукту',
      lockAge: 'Дата народження (Вік)',
      lockAgeTitle: 'Встановити мінімальний вік',
      lockAgeText: 'Відвідувачі повинні бути старші певного віку, щоб розблокувати посилання, ввівши свою дату народження',
      lockAgeAlert: 'Блокування було успішно налаштоване.',
      lockSensitive: 'Чутливий контент',
      lockSensitiveText: 'Відвідувачі повинні визнати, що це посилання може містити контент, який не підходить для всіх аудиторій.',
      makeLink: 'Зробити посилання платним',
      addLock: 'Додати блокування для посилання',
      save: 'Зберегти',
      clear: 'Очистити',
      buttonColor: 'Колір кнопки',
      labelColor: 'Колір мітки',
      background: 'Фон',
      imageHeight: 'Висота зображення',
      imageHeightTooltip: 'Перетягніть повзунок для зміни висоти зображення',
      buttonMinimum: 'Висота',
      buttonMinimumTooltip: 'Перетягніть повзунок для зміни висоти кнопки',
      textPosition: 'Позиція тексту',
      textPositionTooltip: 'Перетягніть повзунок для зміни вертикального положення тексту',
      preview: 'Попередній перегляд',
      defaultDesign: 'Дизайн за замовчуванням',
      defaultDesignTooltip: 'Налаштуйте дизайн посилань за замовчуванням',
      defaultDesignTitle: 'Зверніть увагу, що цей дизайн буде застосовано до всіх посилань.',
      defaultDesignText: 'Ви можете змінити дизайн посилань за замовчуванням',
      changeDefault: 'Змінити за замовчуванням',
      applyDefault: 'Застосувати за замовчуванням',
      scheduled: 'Заплановано',
      scheduledVisible: 'Заплановане посилання тепер видно',
      scheduledHidden: 'Заплановане посилання тепер приховано',
      linkClickable: 'Посилання стане клікабельним через',
      linkDisable: 'Посилання буде вимкнено через',
      lockedBy: 'Заблоковано за',
      items: 'Елементи',
      doNotAnyLinks: 'У вас ще немає жодних посилань',
      sublinks: 'Підпосилання',
      layout: 'Макет',
      layoutTooltip: 'Виберіть макет підпосилань, який ви хочете',
      hideGroupLink: 'Приховати групове посилання',
      rules: 'Правила',
      rulesText: 'Змінюйте видимість цього посилання залежно від того, хто переглядає вашу сторінку.',
      rulesEmpty: 'Ще немає умов. Додайте умову, щоб керувати тим, хто бачить це посилання.',
      rulesAddCondition: 'Додати умову',
      rulesActive: 'Правила видимості',
      rulesIf: 'Якщо',
      rulesThen: 'То',
      ruleTypeLocation: 'Локація',
      ruleTypeDevice: 'Пристрій',
      ruleTypeTime: 'День і час',
      ruleOperatorIs: 'це',
      ruleOperatorIsNot: 'не є',
      ruleActionHide: 'Приховати посилання',
      ruleActionShow: 'Показати посилання',
      ruleSelectLocations: 'Оберіть локації',
      ruleSearchLocations: 'Пошук країн…',
      ruleFrom: 'З',
      ruleTo: 'До',
      ruleAnyTime: 'Будь-який',
    },
    'data-collect': {
      blockTitle: 'Збір даних',
      blockText: 'Збирайте електронні адреси або номери телефонів ваших відвідувачів',
      blockShortText: 'Збирайте електронні адреси',
      maxSize: 'Ви можете додати максимум 3 канали',
      customTerms: 'Індивідуальні Умови',
      customTermsTooltip: 'Додайте індивідуальні умови до вашої форми',
      termsConditions: 'Умови та положення',
      text: 'Текст',
      subscribe: 'Підписатися',
      title: 'Назва',
      titleTooltip: 'Введіть назву для умов та положень',
      titleResultTooltip: 'Введіть заголовок для вашого відправлення',
      url: 'URL',
      urlTooltip: 'Введіть URL',
      editItem: 'Редагувати елемент',
      placeholder: 'Заповнювач',
      placeholderTooltip: 'Введіть текст заповнювача',
      button: 'Кнопка',
      buttonTooltip: 'Текст, який мотивує відвідувача ввести електронну адресу (знижка 10%, підпишіться зараз, завантажте файл тощо)',
      successMessage: 'Повідомлення про успіх',
      successMessageTooltip: 'Повідомлення про успіх ваших підписок',
      botURL: 'URL бота (необов’язково)',
      botURLTooltip: 'Введіть URL вашого бота',
      botToken: 'Токен бота',
      botTokenTooltip: 'Введіть токен вашого бота',
      rewards: 'Нагороди',
      rewardsTooltip: 'Додайте нагороди для ваших підписок',
      addReward: 'Додати нагороду',
      thankYou: 'Повідомлення подяки',
      email: {
        none: 'Немає',
        display: 'Показати нагороду миттєво',
        send: 'Надіслати нагороду на електронну пошту',
        redirect: 'Перенаправити на URL',
      },
      phone: {
        none: 'Немає',
        display: 'Показати нагороду миттєво',
        send: 'Надіслати нагороду на телефон',
        redirect: 'Перенаправити на URL',
      },
      telegram: {
        none: 'Немає',
        display: 'Показати нагороду миттєво',
        send: 'Надіслати нагороду через Telegram бот',
        redirect: 'Перенаправити на URL',
      },
      whatsapp: {
        none: 'Немає',
        display: 'Показати нагороду миттєво',
        send: 'Надіслати нагороду через WhatsApp бот',
        redirect: 'Перенаправити на URL',
      },
      instagram: {
        none: 'Немає',
        display: 'Показати нагороду миттєво',
        send: 'Надіслати нагороду через Instagram бот',
        redirect: 'Перенаправити на URL',
      },
      messenger: {
        none: 'Немає',
        display: 'Показати нагороду миттєво',
        send: 'Надіслати нагороду через Messenger бот',
        redirect: 'Перенаправити на URL',
      },
      viber: {
        none: 'Немає',
        display: 'Показати нагороду миттєво',
        send: 'Надіслати нагороду через Viber бот',
        redirect: 'Перенаправити на URL',
      },
      connect: 'Підключити',
      toChangeReward: 'Щоб змінити тип нагороди, потрібно видалити поточну',
      remove: 'Видалити',
      viewTypes: 'Типи відображення',
    },
    form: {
      blockTitle: 'Форма',
      blockText: 'Дозволяє збирати інформацію та дані від вашої аудиторії',
      blockShortText: 'Збирання даних',
      fields: 'Поля',
      fieldsTooltip: 'Додайте поля до форми',
      addCustomField: 'Додати власне поле',
      addItem: 'Додати елемент',
      editItem: 'Редагувати елемент',
      type: 'Тип',
      typeTooltip: 'Виберіть тип поля',
      string: 'Текстовий рядок',
      textarea: 'Текстова область',
      dropdown: 'Випадний список',
      radio: 'Радіо',
      checkbox: 'Прапорець',
      date: 'Дата',
      time: 'Час',
      country: 'Країна',
      fieldName: 'Назва поля',
      fieldNameTooltip: 'Введіть назву поля',
      name: 'Ім’я',
      placeholder: 'Заповнювач',
      placeholderTooltip: 'Введіть текст заповнювача',
      required: 'Обов’язково',
      requiredTooltip: 'Позначте, якщо поле обов’язкове',
      value: 'Значення',
      enterTitle: 'Введіть заголовок',
      addValue: 'Додати значення',
      delete: 'Видалити',
      update: 'Оновити',
      add: 'Додати',
      confirmationPage: 'Результуюча дія',
      confirmationPageSubtitle: 'Виберіть результат дії після відправки форми',
      successMessage: 'Повідомлення про успіх',
      successMessageTooltip: 'Повідомлення про успіх після відправки форми',
      thankYou: 'Повідомлення подяки',
      submit: 'Відправити',
    },
    contact: {
      blockTitle: 'Контакти',
      blockText: 'Контакти дозволяють користувачам спілкуватися з вами безпосередньо. Додайте свій телефон, електронну адресу, месенджер або місцезнаходження',
      blockShortText: 'Спілкування з клієнтами',
      addNewContact: 'Додати новий контакт',
      newContact: 'Новий контакт',
      friendlyName: "Зручне ім'я",
    },
    faq: {
      blockTitle: 'Часті запитання',
      blockText: 'Часті запитання — використовується для позначення списку відповідей на типові питання, які можуть виникнути у користувачів',
      blockShortText: 'Часті запитання',
      addNewItem: 'Додати новий елемент',
      editItem: 'Рудакувати елемент',
      title: 'Заголовок',
      titleTooltip: 'Введіть заголовок',
      description: 'Опис',
      descriptionTooltip: 'Введіть опис',
      update: 'Оновити',
      add: 'Додати',
      howToFind: 'Як нас знайти',
      view: 'Вигляд',
      viewTooltip: 'Оберіть, як відображати питання FAQ',
      feed: 'Стрічка',
      slider: 'Слайдер',
    },
    ama: {
      blockTitle: 'Запитай мене',
    },
    feature: {
      blockTitle: 'Особливості',
      blockText: 'Текстовий розділ із зображенням, щоб розповісти вашим користувачам, чому ваш бізнес найкращий',
      blockShortText: 'Розповісти вашим користувачам, чому',
      title: 'Заголовок',
      titleTooltip: 'Змінити заголовок елемента',
      description: 'Опис',
      descriptionTooltip: 'Змінити опис елемента',
    },
    highlight: {
      blockTitle: 'Основні моменти',
      blockText: 'Виділіть найважливіші посилання з ескізами (до 3)',
      blockShortText: 'Виділіть найважливіші посилання',
      title: 'Заголовок',
      titleTooltip: 'Змінити заголовок елемента',
      url: 'URL',
      urlTooltip: 'Змінити URL елемента',
    },
    banner: {
      blockTitle: 'Банер',
      blockText:
        'Показуйте зображення, відео або ваш останній продукт, щоб він виділявся. Ви можете додати кнопку заклику до дії, щоб направити користувачів до вашої мети конверсії',
      blockShortText: 'Показуйте зображення, відео',
      height: 'Висота',
      heightTooltip: 'Змініть висоту банера',
    },
    slider: {
      blockTitle: 'Слайдер',
      blockText: 'Карусель зображень, яка дозволяє демонструвати ваші зображення та додавати різні функції',
      blockShortText: 'Карусель зображень',
      image: 'Зображення',
      imageTooltip: 'Зображення вашої галереї',
      addText: 'Додати текст',
      title: 'Заголовок',
      titleTooltip: 'Заголовок вашого слайда',
      titleSize: 'Розмір заголовка',
      titleSizeTooltip: 'Виберіть розмір для кращого читання',
      description: 'Опис',
      descriptionTooltip: 'Опис вашого слайда',
      textColor: 'Колір тексту',
      addButton: 'Додати кнопку',
      url: 'URL',
      urlTooltip: 'URL вашого зображення',
      button: 'Кнопка',
      buttonTooltip: 'Назва вашої кнопки',
      buttonText: 'Текст кнопки',
      buttonColor: 'Колір кнопки',
      height: 'Висота',
      heightTooltip: 'Змінити висоту для слайдів',
      view: 'Вид',
      viewTooltip: 'Виберіть вигляд для слайдера',
      auto: 'Авто',
      square: 'Квадрат',
      rectangle: 'Прямокутник',
      single: 'Одинарний',
      multi: 'Множинний',
    },
    gallery: {
      blockTitle: 'Галерея',
      blockText: 'Карусель зображень, яка дозволяє демонструвати ваші зображення',
      blockShortText: 'Карусель зображень',
      image: 'Зображення',
      imageTooltip: 'Зображення вашого елемента галереї',
      layout: 'Макет',
      layoutTooltip: 'Виберіть макет для галереї',
      feed: 'Стрічка',
      slider: 'Слайдер',
    },
    blog: {
      blockTitle: 'Блог',
      blockText: 'Створіть блог зі своїми публікаціями',
      blockShortText: 'Створіть блог',
      writeYourStory: 'Напишіть свою історію',
      shortDescription: 'Короткий опис',
      shortDescriptionTooltip: 'Необов’язковий опис для вашого блогу',
      description: 'Опис',
    },
    map: {
      blockTitle: 'Карта',
      blockText: 'Додайте карту Google, щоб допомогти користувачам знайти ваш місцевий бізнес',
      blockShortText: 'Додати карту Google',
      buttonText: 'Текст кнопки',
      buttonTextTooltip: 'Кнопка з’являється, коли вибрано другий вигляд',
      text: 'Текст',
      addAddress: 'Додати іншу адресу',
      address: 'Адреса',
      addressTooltip: 'Вставте адресу з Google Maps, наприклад',
      googleMap: 'Google карта (код для вбудовування)',
      googleMapTooltip: 'Вставте код для вбудовування з Google Maps',
      howToFind: 'Як знайти код для вбудовування',
      incorrectCode: 'Некоректний код для вбудовування.',
      moreInfo: 'Додаткова інформація',
      code: 'Код',
      addressSettings: 'Налаштування адреси',
      addressContent: 'Додайте URL, заголовок та текст або іконку кнопки',
      title: 'Заголовок',
      titleTooltip: 'Назва вашої адреси',
      url: 'URL',
      urlTooltip: 'Вставте URL адреси з Google Maps, наприклад',
      directionText: 'Текст напрямку',
      directionTextTooltip: 'Текст заклику до дії для ваших користувачів',
    },
    footer: {
      blockTitle: 'Футер',
      blockText: 'Розділ вмісту в самому низу сторінки. Ви можете додати контактну інформацію, іконки соціальних мереж та форму підписки на електронну пошту',
      blockShortText: 'Розділ вмісту внизу сторінки',
      addBlock: 'Додати блок',
      blockType: 'Тип блоку',
      blockTypeTooltip: 'Виберіть тип блоку',
      addBlockTitle: 'Заголовок блоку',
      addBlockTitleTooltip: 'Виберіть заголовок блоку',
      faq: 'Часті питання (FAQ)',
      'data-collect': 'Збір даних',
      contact: 'Контакт',
      pages: 'Сторінки',
      payments: 'Платежі',
      social: 'Соціальні мережі',
      cancel: 'Скасувати',
      add: 'Додати',
      None: 'Немає',
      link: 'Посилання',
      faqText: 'Ви можете редагувати часті питання у блоці FAQ. Ви можете перейти до нього, натиснувши тут',
      socialText: 'Ви можете редагувати іконки соціальних мереж у блоці заголовка. Ви можете перейти до нього, натиснувши тут',
      dataCollectText: 'Ви можете редагувати збір даних у блоці "Збір даних". Ви можете перейти до нього, натиснувши тут',
      contactText: 'Ви можете редагувати контактні дані у блоці "Контакт". Ви можете перейти до нього, натиснувши тут',
      pagesText: 'Ви можете додати нові сторінки на сайт',
      paymentsText: 'Методи оплати будуть відображені',
      showOnAllpages: 'Показувати на всіх сторінках',
      footerText: 'Футер з головної сторінки наразі увімкнено.',
      editSocialIcons: 'Ви можете редагувати значки соціальних мереж у розділі Заголовок. Ви можете перейти до нього, натиснувши тут',
      editSubscribe: 'Ви можете редагувати підписку в розділі Підписатися. Перейти до нього можна, натиснувши тут',
      editContacts: 'Ви можете редагувати контакти в розділі Контакти. Ви можете перейти до нього, натиснувши тут',
      editFrequently: 'Ви можете редагувати поширені запитання в розділі FAQ. Ви можете перейти до нього, натиснувши тут',
    },
    'chat-ai': {
      blockTitle: 'AI-чат',
      blockShortText: 'Спілкуйтеся з AI',
      blockText: 'Спілкуйтеся з AI',
      suggestionsTitle: 'Пропозиції',
      suggestionsSubtitle: 'Швидкі підказки',
    },
    custom: {
      blockTitle: 'Custom',
      blockShortText: 'Мікро-додаток на основі AI',
      blockText: 'Опишіть міні інтерактивний додаток і AI згенерує його для вас',
    },
    shop: {
      blockTitle: 'Магазин',
      blockText: 'Додайте список своїх продуктів',
      blockShortText: 'Додайте свої продукти',
      view: 'Вигляд',
      products: 'Продукти',
      categories: 'Категорії',
    },
    digital: {
      blockTitle: 'Цифрові продукти',
      blockText: 'Продавайте цифрові завантаження: PDF, електронні таблиці, шаблони, ексклюзивний вміст тощо',
      blockShortText: 'Продавайте цифрові продукти',
    },
    podcast: {
      blockTitle: 'Подкасти',
      blockText: 'Рекламуйте свої подкасти',
      blockShortText: 'Рекламуйте свої подкасти',
    },
    'page-list': {
      blockTitle: 'Список сторінок',
      blockText: 'Відображайте список ваших сторінок із заголовками та описами для зручної навігації.',
      blockShortText: 'Перелічіть ваші сторінки.',
    },
    appointment: {
      blockTitle: 'Записи',
      blockText: 'Дозвольте відвідувачам бронювати час у вашому календарі',
      blockShortText: 'Дозвольте бронювати час',
    },
    service: {
      blockTitle: 'Послуги',
      blockText: 'Ви отримаєте електронне повідомлення, коли вам надійде запит',
      blockShortText: 'Отримуйте електронні повідомлення',
    },
    requests: {
      blockTitle: 'Запити',
      blockText: 'Ви отримаєте електронне повідомлення, коли вам надійде запит',
      blockShortText: 'Отримуйте електронні повідомлення',
    },
    tips: {
      blockTitle: 'Чайові',
      blockText: 'UniLink робить підтримку веселою та простою. Лише за кілька натискань ваші фани можуть здійснити оплату та залишити повідомлення',
      blockShortText: 'Робить підтримку веселою',
    },
    tip: {
      blockTitle: 'Чайові',
      blockText: 'UniLink робить підтримку веселою та простою. Лише за кілька натискань ваші фани можуть здійснити оплату та залишити повідомлення',
      blockShortText: 'Робить підтримку веселою',
    },
    donation: {
      blockTitle: 'Чайові або пожертви',
      blockText: 'UniLink робить підтримку веселою та легкою. Ваші шанувальники можуть зробити платіж та залишити повідомлення всього за кілька натискань',
      blockShortText: 'Робить підтримку веселою',
    },
    course: {
      blockTitle: 'Курс або навчальний посібник',
      blockText: 'Дозвольте відвідувачам бронювати час у вашому календарі',
      blockShortText: 'Дозвольте бронювати час',
    },
    event: {
      blockTitle: 'Події або квитки',
      blockText: 'Дозвольте аудиторії відвідувати ваші заходи',
      blockShortText: 'Дозвольте відвідувачам відвідувати',
    },
    menu: {
      blockTitle: 'Меню',
      blockText: 'Створіть унікальне меню з цінами',
      blockShortText: 'Створіть унікальне меню',
    },
    booking: {
      blockTitle: 'Бронювання',
      blockText: 'Дозвольте відвідувачам бронювати ваші простори',
      blockShortText: 'Дозвольте бронювання',
      name: 'Назва',
      nameCaption: 'Введіть назву приміщення',
      description: 'Опис',
      descriptionCaption: 'Короткий опис приміщення',
      rentalType: 'Тип оренди',
      rentalTypeCaption: 'Наприклад: квартира, авто, офіс',
      duration: 'Тривалість',
      durationCaption: 'Наприклад: за день, за тиждень, за місяць',
      price: 'Ціна',
      priceCaption: 'Базова ціна за бронювання',
      oldPrice: 'Стара ціна',
      oldPriceCaption: 'Необовʼязково: попередня ціна',
      rating: 'Рейтинг',
      ratingCaption: 'Середній рейтинг (необовʼязково)',
      label: 'Ярлик',
      labelCaption: 'Короткий бейдж, наприклад HOT або NEW',
      image: 'Зображення',
      imageCaption: 'Завантажте обкладинку приміщення',
      location: 'Локація',
      locationCaption: 'Місто, район або адреса',
      capacity: 'Місткість (гостей)',
      capacityCaption: 'Максимальна кількість гостей',
      rooms: 'Кімнати та площа',
      roomsCaption: 'Кількість спалень, ванних та площа',
      bedrooms: 'Спальні',
      bathrooms: 'Ванні кімнати',
      areaSqM: 'Площа (м²)',
      minStay: 'Мінімальний строк (днів)',
      minStayCaption: 'Мінімальна кількість днів для бронювання',
      requiresDeposit: 'Потрібна передоплата',
      depositAmount: 'Сума передоплати',
      depositAmountCaption: 'Сума передоплати для підтвердження бронювання',
      noSmoking: 'Без куріння',
      noPets: 'Без тварин',
      amenitiesWifi: 'Wi‑Fi',
      amenitiesParking: 'Паркування',
      amenitiesKitchen: 'Кухня',
      amenitiesHeating: 'Опалення',
      amenitiesAC: 'Кондиціонер',
      amenitiesPool: 'Басейн',
      amenitiesSauna: 'Сауна',
      amenitiesRestrooms: 'Санвузли',
      validationNameRequired: 'Назва є обовʼязковою',
      validationPriceRequired: 'Ціна має бути невідʼємним числом',
      validationDepositRequired: 'Сума передоплати обовʼязкова, якщо увімкнена передоплата',
      validationCapacityNumber: 'Місткість має бути невідʼємним числом',
      validationOldPriceNumber: 'Стара ціна має бути невідʼємним числом',
      brand: 'Бренд',
      brandCaption: 'Марка авто, наприклад Tesla',
      model: 'Модель',
      modelCaption: 'Модель авто, наприклад Model 3',
      year: 'Рік',
      yearCaption: 'Рік випуску',
      color: 'Колір',
      colorCaption: 'Колір кузова, наприклад чорний',
      fuelType: 'Тип пального',
      fuelTypeCaption: 'Бензин, дизель, електро, гібрид тощо',
      transmission: 'Коробка передач',
      transmissionCaption: 'Автоматична або механічна',
      seatCount: 'Кількість місць',
      seatCountCaption: 'Кількість пасажирських місць',
      edit: 'Редагувати обʼєкт',
      add: 'Додати обʼєкт',
    },
    membership: {
      blockTitle: 'Членство',
      blockText: 'Створіть безкоштовну або платну підписку на ваш вміст',
      blockShortText: 'Створіть підписку',
    },
    pricing: {
      blockTitle: 'Меню / Ціни',
      blockText: 'Створіть унікальне меню з цінами',
      blockShortText: 'Створіть унікальне меню',
      name: 'Назва',
      nameTooltip: 'Введіть назву вашого продукту',
      pricingPlanName: 'Назва тарифного плану',
      pricingPlanNameTooltip: 'Введіть назву вашого тарифного плану',
      description: 'Опис',
      descriptionTooltip: 'Введіть опис вашого продукту',
      pricingPlanDescriptionTooltip: 'Введіть опис вашого тарифного плану',
      priceValue: 'Вартість',
      priceUnit: 'Одиниця вартості',
      label: 'Мітка',
      labelTooltip: 'Введіть мітку вашого тарифного плану',
      orderButtonText: 'Текст кнопки замовлення',
      orderButtonTextDescriptionTooltip: 'Введіть текст кнопки замовлення вашого тарифного плану',
      orderButtonLink: 'Посилання кнопки замовлення',
      orderButtonLinkDescriptionTooltip: 'Введіть посилання кнопки замовлення вашого тарифного плану',
      subtitle: 'Підзаголовок',
      subtitleTooltip: 'Введіть підзаголовок вашого продукту',
      price: 'Ціна',
      priceTooltip: 'Введіть ціну вашого продукту',
      pricingTiers: 'Цінові рівні',
      pricingTiersTooltip: 'Введіть цінові рівні вашого продукту',
      addPriceValue: 'Додати більше цін',
      group: 'Група',
      groupTooltip: 'Виберіть групу для вашого продукту',
      image: 'Зображення',
      imageTooltip: 'Завантажте зображення для вашого продукту',
      unit: 'Одиниця ціни',
      unitTooltip: 'Введіть одиницю вашої ціни',
      addUnitTitle: 'Одиниці ціни',
      addPriceUnitValue: 'Додати більше одиниць ціни',
      addUnitButtonText: 'Зберегти',
      button: 'Кнопка',
      buttonTooltip: 'Додайте кнопку для вашого продукту',
      buttonAddText: '+ Додати кнопку',
      buttonModalTextField: 'Текст кнопки',
      buttonModalTextFieldTooltip: 'Введіть текст кнопки',
      buttonModalURLField: 'URL кнопки',
      buttonModalURLFieldTooltip: 'Введіть URL кнопки',
      buttonModalTitle: 'Додати кнопку',
      groups: {
        title: 'Групи',
        subtitle: 'Додавайте, редагуйте та видаляйте групи',
        groups: 'Групи',
        groupsTooltip: 'Додавайте, редагуйте та видаляйте групи',
        addNewGroup: 'Додати нову групу',
        newGroup: 'Нова група',
        titleGroup: 'Назва',
        titleGroupTooltip: 'Введіть назву вашої групи',
        descriptionGroup: 'Опис',
        descriptionGroupTooltip: 'Введіть опис вашої групи',
      },
    },
    menuBlock: {
      title: 'Меню',
      subtitle: 'Створіть меню з пунктами та цінами',
      add: 'Додати новий пункт',
      edit: 'Редагувати пункт',
      name: 'Назва',
      nameCaption: 'Введіть назву пункту',
      description: 'Опис',
      descriptionCaption: 'Введіть короткий опис',
      ingredients: 'Інгредієнти',
      ingredientsCaption: 'Вкажіть інгредієнти або склад',
      price: 'Ціна',
      priceCaption: 'Введіть ціну',
      weight: 'Вага (г)',
      weightCaption: 'Введіть вагу в грамах',
      calories: 'Калорії (ккал)',
      caloriesCaption: 'Введіть калорії в ккал',
      label: 'Мітка',
      labelCaption: 'Введіть текст мітки',
      labelColor: 'Колір мітки',
      labelColorCaption: 'Виберіть колір фону мітки',
      image: 'Зображення',
      imageCaption: 'Завантажте зображення для вашого пункту',
      available: 'Доступно для замовлення',
      visible: 'Видимо на сторінці',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Показуйте NFT з платформи OpenSea',
      blockShortText: 'Показуйте NFT',
    },
    wallet: {
      wallet: 'Гаманець',
      blockTitle: 'Банк/Крипто-Гаманець',
      blockText: 'Відображає вашу кредитну картку або Bitcoin-адресу, щоб користувачам було зручніше копіювати її для переказу коштів.',
      blockShortText: 'Відображайте ваші гаманці',
      title: 'Заголовок',
      titleTooltip: 'Заголовок вашого гаманця',
      walletNumber: 'Номер гаманця',
      walletNumberTooltip: 'Вставте номер вашого гаманця',
      icon: 'Іконка',
      iconTooltip: 'Встановіть іконку для вашого гаманця',
      card: 'Картка',
      bank: 'Банк',
      crypto: 'Криптовалюта',
      transfer: 'Переказ',
      paymentLink: 'Посилання для оплати',
      cardNumber: 'Номер картки',
      cardNumberTooltip: 'Вставте номер картки',
      cardHolder: 'Власник картки',
      cardHolderTooltip: 'Вкажіть ім’я власника картки',
      bankAccountDetails: 'Реквізити банківського рахунку',
      bankAccountDetailsTooltip: 'Введіть реквізити вашого банківського рахунку',
      walletAddress: 'Адреса гаманця',
      walletAddressTooltip: 'Введіть адресу вашого крипто-гаманця',
      network: 'Мережа',
      networkTooltip: 'Вкажіть блокчейн-мережу',
      publicKey: 'Публічний ключ',
      publicKeyTooltip: 'Введіть ваш публічний ключ',
      providerName: 'Назва провайдера',
      providerNameTooltip: 'Введіть назву вашого провайдера',
      link: 'Посилання',
      linkTooltip: 'Введіть ваше платіжне посилання',
      serviceName: 'Назва сервісу',
      serviceNameTooltip: 'Введіть назву вашого сервісу',
      email: 'Електронна пошта',
      emailTooltip: 'Введіть вашу електронну адресу',
      phone: 'Телефон',
      phoneTooltip: 'Введіть ваш номер телефону',
      username: 'Ім’я користувача',
      usernameTooltip: 'Введіть ваше ім’я користувача',
      fullName: 'Повне ім’я',
      fullNameTooltip: 'Введіть ваше повне ім’я',
      referenceNumber: 'Референсний номер',
      referenceNumberTooltip: 'Введіть ваш референсний номер',
      country: 'Країна',
      countryTooltip: 'Введіть вашу країну',
      transferProvider: 'Провайдер переказу',
      transferProviderTooltip: 'Введіть провайдера переказу',
      cryptoCurrency: 'Криптовалюта',
      cryptoCurrencyTooltip: 'Введіть вашу криптовалюту',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Показуйте свої найкращі медіа та відео з Instagram або продавайте свої продукти через шопінг-стрічку Instagram',
      blockShortText: 'Ваші найкращі медіафайли з Instagram',
      blockConnectTitle: 'Instagram не підключений',
      blockConnectText: 'Схоже, ваші товари з Instagram ще не імпортовані. Підключіть свій обліковий запис зараз',
      blockConnectButton: 'Додати Instagram',
      emptyList: 'У вас ще немає медіафайлів з Instagram.',
      addInstagramUsername: "Додати ім'я користувача Instagram",
      username: "Ім'я користувача",
      downloadTakes: 'Завантаження займає до 2 хвилин',
      displayPost: 'Показати пост на вашому сайті',
      view: 'Перегляд',
      redirect: 'Переадресація URL',
      text: 'Текст та кнопка',
      actionType: 'Тип дії',
      url: 'URL',
      openInNewTab: 'Відкрити в новій вкладці',
      delete: 'Видалити',
      cancel: 'Скасувати',
      save: 'Зберегти',
      editMedia: 'Редагувати медіа',
      title: 'Заголовок',
      automation: 'Автоматизація',
      automationText: 'Автоматизуйте свій обліковий запис за допомогою функцій Автопілоту',
      autopilot: 'Автопілот',
      autopilotTooltip: 'Завантажте пост зі зразковим підписом, і ваші теги продуктів/посилання будуть автоматично згенеровані',
      switchTitle: 'Автоматично визначати заголовок, ціну, посилання',
      sampleCaption: 'Зразок підпису: #49.99 #NiceDress https://google.com',
      integrations: 'Інтеграції',
      integrationsText: 'Додайте Instagram на ваш сайт',
      connectInstagram: 'Підключити Instagram',
      connectInstagramText: 'Підключіть свій акаунт Instagram, щоб показувати вибрані пости чи Reels.',
      selectAccount: 'Оберіть акаунт',
      connectNewInstagram: 'Підключити новий акаунт Instagram',
      continue: 'Продовжити',
      disconnectInstagram: 'Відключити Instagram',
      addTag: 'Додати тег',
      tagClickHint: 'Натисніть на зображення, щоб розмістити тег',
      tagPositionSet: 'Позицію встановлено. Заповніть деталі нижче.',
      tagTypeLink: 'Посилання',
      tagTypeProduct: 'Продукт',
      tagLabel: 'Підпис',
      tagSelectProduct: 'Оберіть продукт',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Показуйте свої найкращі відео з TikTok або продавайте свої продукти через шопінг-стрічку TikTok',
      blockShortText: 'Ваші найкращі відео з TikTok',
      addTikTok: 'Додати обліковий запис TikTok',
      individualVideo: 'Окреме відео',
      videoCollection: 'Колекція відео',
      add: 'Додати',
      blockConnectTitle: 'TikTok не підключений',
      blockConnectText: 'Схоже, ваші товари з TikTok ще не імпортовані. Підключіть свій обліковий запис зараз',
      blockConnectButton: 'Підключити TikTok',
      enterUsername: "Введіть ім'я користувача",
      enterVideo: 'Введіть URL відео TikTok',
      emptyList: 'У вас ще немає медіафайлів з TikTok.',
      editMedia: 'Редагувати медіа',
      addTikTokVideo: 'Додати відео TikTok',
      displayPost: 'Показати пост на вашому сайті',
      delete: 'Видалити',
      cancel: 'Скасувати',
      save: 'Зберегти',
      integrations: 'Інтеграції',
      integrationsText: 'Додайте TikTok на ваш сайт',
      connectTikTok: 'Підключити TikTok',
      disconnectTikTok: 'Відключити TikTok',
      individualText: "Ви не можете підключити обліковий запис TikTok до цього типу блоку ('окреме відео').",
      individualText2: 'Будь ласка, додайте окреме відео TikTok замість цього.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Показуйте відео або трансляції з YouTube на вашій сторінці. Тегуйте продукти у відео на YouTube',
      blockShortText: 'Відобразіть відео з YouTube',
      enterYouTubeLink: 'Введіть URL YouTube',
      enterYouTubeLinkTooltip: 'Вставте URL YouTube',
    },
    overview: {
      blockTitle: 'Огляд',
      blockText: 'Показуйте відео або трансляції на вашій сторінці. Тегуйте продукти у відео',
      blockShortText: 'Тегувати продукти у відео',
    },
    video: {
      blockTitle: 'Відео',
      blockText: 'Показуйте свої відео на сторінці UniLink для збільшення взаємодії',
      blockShortText: 'Відобразіть відео',
    },
    twitter: {
      blockTitle: 'Twitter',
      blockText: 'Показуйте свої Твіти на сторінці UniLink для збільшення взаємодії',
      blockShortText: 'Показуйте ваші твіти',
      twitterURL: 'Twitter URL',
      twitterURLTooltip: 'Додайте URL з Twitter для генерації вбудованого коду',
      enterTwitterURL: 'Введіть Twitter URL',
    },
    music: {
      blockTitle: 'Музика',
      blockText: 'Вставляйте пісні та плейлисти зі Spotify, SoundCloud або завантажуйте власні аудіофайли',
      blockShortText: 'Додайте вашу музику',
      brand: 'Бренд',
      brandTooltip: 'Виберіть тип для додавання вашої музики',
      url: 'URL',
      embed: 'Код вставки',
      custom: 'Власний',
      musicUrl: 'URL музики',
      musicUrlTooltip: 'Введіть URL вашої музики',
      embedCodeTitle: 'Код вставки',
      embedCodeTooltip: 'Вставте код вставки вашої пісні з обраної музичної платформи',
      audioFile: 'Аудіофайл',
      uploadAudios: 'Тут можна завантажувати лише аудіофайли',
      title: 'Назва',
      titleTooltip: 'Введіть назву вашої музики',
      artist: 'Артист',
      artistTooltip: 'Введіть ім’я виконавця вашої музики',
      audioFileTitle: 'Аудіофайл',
      audioFileTooltip: 'Назва вашого аудіофайлу',
      coverImage: 'Зображення обкладинки',
      coverImageTooltip: 'Завантажте зображення для своєї музики',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Вставляйте відео або трансляції з Twitch на вашу сторінку',
      blockShortText: 'Вставте відео з Twitch',
      twitchURL: 'Twitch URL',
      twitchURLTooltip: 'Вставте URL каналу або назву каналу',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Показати мій канал на Twitch',
      displayChat: 'Показати мій канал на Twitch та чат',
    },
    splash: {
      blockTitle: 'Заставка',
      blockText: "Банер на весь екран з текстом і кнопкою з'являється перед завантаженням сайту для просування будь-якого продукту чи події",
      blockShortText: 'Банер на весь екран',
    },
    promo: {
      blockTitle: 'Промо-бар',
      blockText: 'Виділіть, щоб показати акції',
      blockShortText: 'Виділіть свої акції',
    },
    welcome: {
      blockTitle: 'Вітальне повідомлення',
      blockText: "Напишіть вітальні повідомлення, які заохочують відвідувачів до спілкування. Воно з'являється внизу сторінки для привітання відвідувачів та пропонування допомоги",
      blockShortText: 'Напишіть привітальні повідомлення',
    },
    review: {
      blockTitle: 'Відгуки',
      blockText: 'Відгуки допомагають клієнтам дізнатися більше про продукт і вирішити, чи підходить він їм',
      blockShortText: 'Відгуки допомагають клієнтам',
      name: 'Ім’я',
      nameTooltip: 'Введіть ім’я рецензента',
      comment: 'Коментар',
      commentTooltip: 'Введіть коментар рецензента',
      date: 'Дата',
      dateTooltip: 'Введіть дату рецензії',
      rate: 'Оцінка',
      rateTooltip: 'Встановіть оцінку рецензії',
      image: 'Зображення',
      imageTooltip: 'Завантажте зображення рецензента',
    },
    coupon: {
      blockTitle: 'Купони',
      blockText: 'Інтернет-купон — це код або номер для знижки, який можна використовувати на сайті',
      blockShortText: 'Інтернет-купон для знижки',
    },
    timer: {
      blockTitle: 'Таймер',
      blockText: 'Лічильник зворотного відліку — це віртуальний годинник на сторінці, який відлічує час від певного числа або дати до початку або закінчення події або пропозиції',
      blockShortText: 'Лічильник зворотного відліку',
    },
    outfit: {
      blockTitle: 'Наряд',
      blockText: 'Створіть свій власний список продуктів',
      blockShortText: 'Створіть список продуктів',
    },
    spacer: {
      blockTitle: 'Роздільник',
      blockText: 'Додайте трохи пустого вертикального простору на вашу сторінку',
      blockShortText: 'Додайте порожній простір',
    },
    html: {
      blockTitle: 'HTML код',
      blockText:
        'Ви можете вставити свій HTML код на сторінку UniLink. HTML є стандартною мовою розмітки для створення вебсторінок. Він дозволяє використовувати iframes, секції, параграфи та посилання.',
      blockShortText: 'Вставте свій HTML',
      markupCode: 'Код розмітки',
      markupCodeTooltip: 'Вставте ваш HTML-код',
    },
    unlock: {
      blockTitle: 'Розблокування',
      blockText: 'Ви можете вставити свій розблоковуваний контент на сторінку UniLink.',
      blockShortText: 'Вставте свій контент',
    },
    file: {
      blockTitle: 'Файл',
      blockText:
        'Цей блок дозволяє завантажувати та ділитися файлами, такими як документи, зображення або аудіо. Відвідувачі можуть переглядати або завантажувати їх безпосередньо зі сторінки.',
      blockShortText: 'Завантажуйте та діліться файлами',
      addNewItem: 'Додай новий файл',
      editFile: 'Редагувати файл',
      fileName: "Введи ім'я файлу",
    },
    stat: {
      blockTitle: 'Статистика',
      blockText:
        'Цей блок дозволяє відображати ключові показники вашої сторінки, такі як перегляди, відвідувачі або взаємодія. Він допомагає відстежувати аудиторію та розуміти ефективність сторінки.',
      blockShortText: 'Додайте статистику до своєї сторінки.',
      addNewItem: 'Додати новий показник',
      editItem: 'Редагувати показник',
      statName: 'Введіть назву статистичного показника',
      statValue: 'Введіть значення статистичного показника',
      statDescription: 'Введіть опис статистичного показника',
      statItemFields: 'Вибери поля для відображення',
      feed: 'Стрічка',
      slider: 'Слайдер',
      titleSize: 'Розмір заголовка',
      subtitleTitleSize: 'Ви можете змінити розмір заголовка',
    },
    listing: {
      blockTitle: 'Лістинг',
      blockText: "Відображайте об'єкти нерухомості або товари із зображеннями, деталями та цінами.",
      blockShortText: 'Додайте лістинги на вашу сторінку.',
    },
    rental: {
      blockTitle: 'Оренда',
      blockText: "Розміщуйте об'єкти оренди або товари з доступністю та цінами за період.",
      blockShortText: 'Додайте оренду на свою сторінку.',
    },
    'single-product': {
      blockTitle: 'Окремий товар',
      blockText: 'Презентуйте окремий товар із зображенням, описом і кнопкою купівлі.',
      blockShortText: 'Презентуйте товар.',
    },
    team: {
      blockTitle: 'Команда',
      blockText: 'Представте учасників команди з фото, іменами, ролями та соціальними посиланнями.',
      blockShortText: 'Покажіть свою команду.',
    },
    timetable: {
      blockTitle: 'Розклад',
      blockText: 'Відображайте тижневий розклад занять, подій або сесій.',
      blockShortText: 'Додайте тижневий розклад.',
    },
  },
};
